import moment from "moment";
import stringConstants from "./stringResources.json";
import uniqBy from "lodash/uniqBy";
import { getSearchCountData } from "../apiCalls/jobInfo";

const countryOfDestinations = {
  CANADA: "CA",
  USA: "US",
};

const brokerRoAccess = ["broker-admin@klearnow.com"];

const checkEnv = () => {
  let URL = window._env_.REACT_APP_BROKER_API_URL;
  let env = URL.split('/');
  env = env[3];
  env = env.replace('-broker', '');

  if (["staging", 'pre-prod', "dev", "qat"].includes(env)) {
    return false;
  }
  return true;
}

const acceptedDigitalFileType = ["p12", "cer", "crt", "pfx"];

const OTP_TESTING = checkEnv();

const brokerType = ["BROKER_KN_ADMIN"];

const tabFilters = {
  DEFALT: [
    stringConstants.searchFilters.SEARCH_TAB_ALL,
    stringConstants.searchFilters.SEARCH_TAB_ETA_DAYS,
    stringConstants.searchFilters.SEARCH_TAB_REJECTED,
    stringConstants.searchFilters.SEARCH_TAB_HOLDS,
    stringConstants.searchFilters.SEARCH_TAB_REMAINING_SHIPMENTS,
    stringConstants.searchFilters.SEARCH_TAB_COMPLETED,
    stringConstants.searchFilters.SEARCH_TAB_ALVPH,
    stringConstants.searchFilters.SEARCH_TAB_QUERY,
    stringConstants.searchFilters.SEARCH_TAB_NEW,
  ],
  US: [
    stringConstants.searchFilters.SEARCH_TAB_ALL,
    stringConstants.searchFilters.SEARCH_TAB_ETA_DAYS,
    stringConstants.searchFilters.SEARCH_TAB_REJECTED,
    stringConstants.searchFilters.SEARCH_TAB_HOLDS,
    stringConstants.searchFilters.SEARCH_TAB_REMAINING_SHIPMENTS,
    stringConstants.searchFilters.SEARCH_TAB_COMPLETED,
    stringConstants.searchFilters.SEARCH_TAB_EARLY_BILLING,
    stringConstants.searchFilters.SEARCH_TAB_REFILE,
  ],
  CA: [
    stringConstants.searchFilters.SEARCH_TAB_ALL,
    stringConstants.searchFilters.SEARCH_TAB_NEW,
    stringConstants.searchFilters.SEARCH_TAB_IN_PROCESS,
    stringConstants.searchFilters.SEARCH_TAB_ETA_DAYS,
    stringConstants.searchFilters.SEARCH_TAB_REJECTED,
    stringConstants.searchFilters.SEARCH_TAB_HOLDS,
    stringConstants.searchFilters.SEARCH_TAB_REMAINING_SHIPMENTS,
    stringConstants.searchFilters.SEARCH_TAB_RELEASED,
    stringConstants.searchFilters.SEARCH_TAB_COMPLETED,
    stringConstants.searchFilters.SEARCH_TAB_REFILE,
  ],
  ES: [
    stringConstants.searchFilters.SEARCH_TAB_ALL,
    stringConstants.searchFilters.SEARCH_TAB_ETA_DAYS,
    stringConstants.searchFilters.SEARCH_TAB_REJECTED,
    stringConstants.searchFilters.SEARCH_TAB_HOLDS,
    stringConstants.searchFilters.SEARCH_TAB_REMAINING_SHIPMENTS,
    stringConstants.searchFilters.SEARCH_TAB_RELEASED,
    stringConstants.searchFilters.SEARCH_TAB_COMPLETED,
    stringConstants.searchFilters.SEARCH_TAB_CANCELLED,
  ],
  NL: [
    stringConstants.searchFilters.SEARCH_TAB_ALL,
    stringConstants.searchFilters.SEARCH_TAB_ETA_DAYS,
    stringConstants.searchFilters.SEARCH_TAB_REJECTED,
    stringConstants.searchFilters.SEARCH_TAB_HOLDS,
    stringConstants.searchFilters.SEARCH_TAB_REMAINING_SHIPMENTS,
    stringConstants.searchFilters.SEARCH_TAB_PENDING,
    stringConstants.searchFilters.SEARCH_TAB_COMPLETED,
  ]
};

const searchDirections = {
  descending: stringConstants.searchDirections.DESC,
  ascending: stringConstants.searchDirections.ASC,
};

const allFilters = {
  SEARCH_FILTERS_FILER_CODE: null,
  SEARCH_FILTERS_USER_ID: null,
  SEARCH_FILTERS_KEYWORD: null,
  SEARCH_FILTERS_SHIPMENT_ID: null,
  SEARCH_FILTERS_PRODUCT_DESC: null,
  SEARCH_FILTERS_BOL_NO: null,
  SEARCH_FILTERS_PURCHASE_ORDER: null,
  SEARCH_FILTERS_VESSEL: null,
  SEARCH_FILTERS_START_DATE_OF_UNLADING: null,
  SEARCH_FILTERS_END_DATE_OF_UNLADING: null,
  SEARCH_FILTERS_ENTRY_NUMBER: null,
  SEARCH_FILTERS_COUNTRY: ["US", "GB", "CA", "ES", "NL"],
  SEARCH_FILTERS_SERVICE_TYPE: [1, 2],
  SEARCH_FILTERS_MODE: [
  ],
  // SEARCH_FILTERS_MODE: [
  //   "OCEAN",
  //   "OCEAN_NON_CONTAINER",
  //   "AIR",
  //   "AIR_CONTAINER",
  //   "TRUCK",
  //   "TRUCK_CONTAINER",
  //   "MULTIMODAL",
  //   "RAIL",
  //   "RAIL_CONTAINER",
  //   "PIPELINE",
  // ],
  SEARCH_FILTERS_KXEMAIL: null,
  SEARCH_FILTERS_LVS_MONTH: null,
  SEARCH_FILTERS_LVS_YEAR: null,
  SEARCH_FILTERS_CONTAINER_NO: null,
  SEARCH_FILTERS_WORKFLOW_STATE: null,
};

const textFiltersLabelMapper = {
  SEARCH_FILTERS_SHIPMENT_ID:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_SHIPMENT_ID,
  SEARCH_FILTERS_PRODUCT_DESC:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_PRODUCT_DESC,
  SEARCH_FILTERS_BOL_NO: stringConstants.textFiltersLabel.SEARCH_FILTERS_BOL_NO,
  SEARCH_FILTERS_PURCHASE_ORDER:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_PURCHASE_ORDER,
  SEARCH_FILTERS_VESSEL: stringConstants.textFiltersLabel.SEARCH_FILTERS_VESSEL,
  SEARCH_FILTERS_ENTRY_NUMBER:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_ENTRY_NUMBER,
  SEARCH_FILTERS_COUNTRY:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_COUNTRY,
  SEARCH_FILTERS_SERVICE_TYPE:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_SERVICE_TYPE,
  SEARCH_FILTERS_MODE: stringConstants.textFiltersLabel.SEARCH_FILTERS_MODE,
  SEARCH_FILTERS_KXEMAIL:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_KXEMAIL,
  SEARCH_FILTERS_LVS_MONTH:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_LVS_MONTH,
  SEARCH_FILTERS_LVS_YEAR:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_LVS_YEAR,
  SEARCH_FILTERS_CONTAINER_NO:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_CONTAINER_NO,
  SEARCH_FILTERS_WORKFLOW_STATE:
    stringConstants.textFiltersLabel.SEARCH_FILTERS_WORKFLOW_STATE,
  SEARCH_FILTERS_LRN: stringConstants.textFiltersLabel.SEARCH_FILTERS_LRN,
  SEARCH_FILTERS_MRN: stringConstants.textFiltersLabel.SEARCH_FILTERS_MRN,
};

const cardFiltersLabelMapper = {
  SEARCH_FILTERS_FILER_CODE:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_FILER_CODE,
  SEARCH_FILTERS_USER_ID:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_USER_ID,
  SEARCH_FILTERS_SHIPMENT_ID:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_SHIPMENT_ID,
  SEARCH_FILTERS_PRODUCT_DESC:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_PRODUCT_DESC,
  SEARCH_FILTERS_BOL_NO: stringConstants.cardFiltersLabel.SEARCH_FILTERS_BOL_NO,
  SEARCH_FILTERS_PURCHASE_ORDER:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_PURCHASE_ORDER,
  SEARCH_FILTERS_VESSEL: stringConstants.cardFiltersLabel.SEARCH_FILTERS_VESSEL,
  SEARCH_FILTERS_KEYWORD:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_KEYWORD,
  SEARCH_FILTERS_ENTRY_NUMBER:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_ENTRY_NUMBER,
  SEARCH_FILTERS_COUNTRY:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_COUNTRY,
  SEARCH_FILTERS_SERVICE_TYPE:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_SERVICE_TYPE,
  SEARCH_FILTERS_KXEMAIL:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_KXEMAIL,
  SEARCH_FILTERS_LVS_MONTH:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_LVS_MONTH,
  SEARCH_FILTERS_LVS_YEAR:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_LVS_YEAR,
  SEARCH_FILTERS_CONTAINER_NO:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_CONTAINER_NO,
  SEARCH_FILTERS_WORKFLOW_STATE:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_WORKFLOW_STATE,
  SEARCH_FILTERS_LRN:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_LRN,
  SEARCH_FILTERS_MRN:
    stringConstants.cardFiltersLabel.SEARCH_FILTERS_MRN,
};

// Do not change order
let textFilters = [
  "SEARCH_FILTERS_WORKFLOW_STATE",
  "SEARCH_FILTERS_FILER_CODE",
  "SEARCH_FILTERS_USER_ID",
  "SEARCH_FILTERS_SHIPMENT_ID",
  "SEARCH_FILTERS_ENTRY_NUMBER",
  "SEARCH_FILTERS_BOL_NO",
  "SEARCH_FILTERS_PURCHASE_ORDER",
  "SEARCH_FILTERS_PRODUCT_DESC",
  "SEARCH_FILTERS_MODE",
  "SEARCH_FILTERS_CONTAINER_NO",
  "SEARCH_FILTERS_KXEMAIL",
  "SEARCH_FILTERS_LVS_MONTH",
  "SEARCH_FILTERS_LVS_YEAR",
  // 'SEARCH_FILTERS_COUNTRY',
  // 'SEARCH_FILTERS_SERVICE_TYPE'
  // 'SEARCH_FILTERS_VESSEL'
];

const nctsTextFilters = [
  "SEARCH_FILTERS_WORKFLOW_STATE",
  "SEARCH_FILTERS_KXEMAIL",
  "SEARCH_FILTERS_FILER_CODE",
  "SEARCH_FILTERS_USER_ID",
  "SEARCH_FILTERS_SHIPMENT_ID",
  "SEARCH_FILTERS_MRN",
  "SEARCH_FILTERS_LRN",
  "SEARCH_FILTERS_MODE",
  "SEARCH_FILTERS_CONTAINER_NO"
]

const euTextFilters = [
  "SEARCH_FILTERS_WORKFLOW_STATE",
  "SEARCH_FILTERS_KXEMAIL",
  "SEARCH_FILTERS_FILER_CODE",
  "SEARCH_FILTERS_USER_ID",
  "SEARCH_FILTERS_SHIPMENT_ID",
  "SEARCH_FILTERS_MRN",
  "SEARCH_FILTERS_MODE",
  "SEARCH_FILTERS_SERVICE_TYPE",
  "SEARCH_FILTERS_CONTAINER_NO"
]

const timerStatusToColor = {
  red: "#F15C22",
  yellow: "#F5A623",
  green: "#0CCE3E",
};

const checkMarkEvents = {
  "Payment completed": true,
  "Containers Unloaded and Ready for Pickup": true,
  "All Container(s) have Reached their Destination": true,
  Completed: true,
};

const mapper = {
  New: "Shipment Created",
  "ISF was filed for shipment": "ISF was Filed",
  "ISF was accepted for shipment": "ISF Filing was Accepted",
  "Vessel departed from port of lading":
    "Vessel has Departed from the Origin Port",
  "Cargo release completed": "Cargo Release has been Filed",
  container: "Container In Route",
  "Cargo release accepted": "Cargo Release has been Accepted",
  "Entry release completed": "Entry Summary has been Filed",
  "Entry release accepted": "Entry Summary has been Accepted",
  "Vessel arrived at port of unlading":
    "Vessel has Arrived at it's Destination Port",
  "Containers Unloaded and Ready for Pickup":
    "All Containers have been Picked Up!",
  "All Container(s) have Reached their Destination":
    "0/2 Container(s) have been Delivered",
  "Trucker departed": "Trucker has Departed from the Destination Port",
  Completed: "All Containers have been Returned and the Shipment is Completed!",
  "Assigned to broker": "A Broker has been Assigned",
};

const mapperFuture = {
  New: "Shipment Created",
  "ISF was filed for shipment": "ISF to be Filed",
  "Vessel departed from port of lading":
    "Vessel to depart from the Origin Port",
  "Cargo release completed": "Cargo Release to be Filed",
  "Entry release completed": "Entry Summary to be Filed",
  "Vessel arrived at port of unlading": "Vessel to Arrive at Destination Port",
  "Trucker departed": "Trucker(s) to Depart from the Destination Port",
  "All Container(s) have Reached their Destination":
    "Container(s) to be Delivered",
  Completed: "The Shipment is not yet Complete",
};

const cargoReleaseStatusMap = (description, shipmentCountry) => {
  let shipmentCntry = shipmentCountry || window.shipmentCountry;
  if (
    cargoReleaseMapper[shipmentCntry] &&
    cargoReleaseMapper[shipmentCntry][description]
  )
    return cargoReleaseMapper[shipmentCntry][description];
  return {
    text: description,
    color: "lightgray",
  };
};

const entrySummaryStatusMap = (description, shipmentCountry) => {
  let shipmentCntry = shipmentCountry || window.shipmentCountry;
  if (
    entrySummaryMapper[shipmentCntry] &&
    entrySummaryMapper[shipmentCntry][description]
  ) {
    return entrySummaryMapper[shipmentCntry][description];
  }
  return {
    text: description,
    color: "lightgray",
  };
};

const pscStatusMap = (description, shipmentCountry) => {
  let shipmentCntry = shipmentCountry || window.shipmentCountry;
  if (pscMapper[shipmentCntry] && pscMapper[shipmentCntry][description])
    return pscMapper[shipmentCntry][description];
  return {
    text: description,
    color: "lightgray",
  };
};

const nctsStatusMap = (description) => {
  if (nctsMapper[description]) return nctsMapper[description];
  return {
    text: description,
    color: "lightgray"
  };
}

const transitStatusMap = (description) => {
  if (transitMapper[description]) return transitMapper[description];
  return {
    text: description,
    color: "lightgray"
  };
}

const statusMap = (mapper, description) => {
  if (mapper[description]) return mapper[description];
  return {
    text: description,
    color: "lightgray"
  };
}

const statusTextMapper = {
  CONTENT_ACCEPTED: "CONTENT_ACCEPTED",
  CONTENT_REJECTED: "CONTENT_REJECTED",
  GOODS_RELEASED: "GOODS_RELEASED",
  EXAMINATION_REFERRED: "EXAMINATION_REFERRED",
  DETAIN: "DETAIN",
  ARRIVAL_OF_GOODS: "ARRIVAL_OF_GOODS ",
  CUSTOMS_PROCESSING: "CUSTOMS_PROCESSING ",
  ERROR_MESSAGE: "ERROR_MESSAGE ",
  AUTHORISED: "AUTHORISED",
  FILED: "FILED",
  PENDING: "PENDING FILING",
  REJECTED: "REJECTED",
  IN_PROCESS: "IN PROCESS",
  ON_HOLD: "ON HOLD",
  IN_QUEUE: "IN QUEUE",
  NEW: "NEW",
  BROKER_ASSIGNED: "BROKER ASSIGNED",
  ACCEPTED: "ACCEPTED",
  RETRACT_FILED: "CANCEL FILED",
  RETRACT_ACCEPTED: "CANCELLED",
  RETRACT_REJECTED: "CANCEL REJECTED",
  ACCEPTED_WARNINGS: "ACC W/ WARNINGS",
  READY: "READY",
  ACKNOWLEDGED: "ACKNOWLEDGED",
  ARRIVAL_NOTICE_RECEIVED: "ARRIVAL NOTICE RECEIVED",
  CHECKPOINT_FAILED: "CHECKPOINT FAILED",
  CANCELED: "CANCELED",
  AMEND_IN_PROCESS: "AMEND IN PROCESS",
  AMEND_READY: "AMEND READY",
  AMEND_FILED: "AMEND FILED",
  ROUTE_0: "ROUTE 0",
  ROUTE_1_C: "ROUTE 1_C",
  ROUTE_1: "ROUTE 1",
  ROUTE_2: "ROUTE 2",
  ROUTE_2_C: "ROUTE 2_C",
  ROUTE_3_C: "ROUTE 3_C",
  ROUTE_6_C: "ROUTE 6_C",
  ROUTE_3: "ROUTE 3",
  ROUTE_5: "ROUTE 5",
  ROUTE_6: "ROUTE 6",
  ROUTE_E: "ROUTE E",
  ROUTE_F: "ROUTE F",
  ROUTE_H: "ROUTE H",
  FEC_FAILED: "FEC FAILED (Accepted with warning)",
  AMEND_ACCEPTED: "AMEND ACCEPTED",
  AMEND_REJECTED: "AMEND REJECTED",
  CANCEL_FILED: "CANCEL FILED",
  CANCEL_ACKNOWLEDGED: "CANCEL ACKNOWLEDGED",
  CANCEL_ACCEPTED: "CANCELLED",
  CANCEL_REJECTED: "CANCEL REJECTED",
  RELEASE_CANCEL_ACCEPTED:"CANCEL ACCEPTED",
  RELEASE_CANCEL_FILED:"CANCEL FILED",
  RELEASE_CANCEL_REJECTED:"CANCEL REJECTED",
  ACCOUNTING_CANCEL_ACCEPTED:"CANCEL ACCEPTED",
  ACCOUNTING_CANCEL_FILED:"CANCEL FILED",
  ACCOUNTING_CANCEL_REJECTED:"CANCEL REJECTED",
  APPROVAL_PENDING:"APPROVAL PENDING",
  AMEND_APPROVAL_PENDING:"AMEND APPROVAL PENDING"
};
const pscTextMapper = {
  PSC_NONE: "PSC NONE",
  PSC_FILED: "PSC FILED",
  PSC_REJECTED: "PSC REJECTED",
  PSC_IN_PROCESS: "PSC IN PROCESS",
  PSC_NEW: "PSC STARTED",
  PSC_ACCEPTED: "ACCEPTED",
  PSC_READY: "PSC READY",
  PSC_CANCELED: "PSC CANCELED",
  STATE_PSC_ACCEPTED_WITH_WARNING: "PSC ACC W/ WARNS",
};

const languageList = [
  { value: "en", text: "English", key: "EN", flag: "us" },
  { value: "nl", text: "Dutch", key: "NL", flag: "nl" },
  { value: "de", text: "German", key: "DE", flag: "de" },
  { value: "es", text: "Spanish", key: "ES", flag: "es" }
];

const nctsTextMapper = {
  TRANSIT_NONE: 'TRANSIT NONE',
  TRANSIT_NEW: 'TRANSIT NEW',
  TRANSIT_PENDING: 'TRANSIT PENDING',
  TRANSIT_IN_PROCESS: 'TRANSIT IN PROCESS',
  TRANSIT_FILING_IN_PROCESS: 'TRANSIT FILING IN PROCESS',
  TRANSIT_FILE_READY: 'TRANSIT FILE READY',
  TRANSIT_FILED: 'TRANSIT FILED',
  TRANSIT_FILED_FAILED: 'TRANSIT FILE FAILED',
  TRANSIT_FILED_REJECTED: 'TRANSIT FILE REJECTED',
  TRANSIT_CANCELLATION_FILED: 'TRANSIT CANCELLATION FILED',
  TRANSIT_CANCELLATION_FILED_FAILED: 'TRANSIT CANCELLATION FILED FAILED',
  TRANSIT_CANCELLATION_ACCEPTED: 'TRANSIT CANCELLATION ACCEPTED',
  TRANSIT_FILED_ACKNOWLEDGED: 'TRANSIT FILED ACKNOWLEDGED',
  TRANSIT_ACCEPTED: 'TRANSIT ACCEPTED',
  TRANSIT_COMPLETE: 'TRANSIT COMPLETE',
  TRANSIT_SKIPPED: 'TRANSIT SKIPPED',

  ARRIVAL_IN_PROCESS: 'ARRIVAL IN PROCESS',
  ARRIVAL_FILING_IN_PROCESS: 'ARRIVAL FILING IN PROCESS',
  ARRIVAL_FILE_READY: 'ARRIVAL FILE READY',
  ARRIVAL_FILED: 'ARRIVAL FILED',
  ARRIVAL_FILED_FAILED: 'ARRIVAL FILE FAILED',
  ARRIVAL_FILED_ACKNOWLEDGED: 'ARRIVAL FILE ACKNOWLEDGED',
  ARRIVAL_FILED_REJECTED: 'ARRIVAL FILED REJECTED',
  ARRIVAL_CANCELLATION_FILED: 'ARRIVAL CANCELLATION FILED',
  ARRIVAL_ACCEPTED: 'ARRIVAL ACCEPTED',

  UNLOADING_IN_PROCESS: 'UNLOADING IN PROCESS',
  UNLOADING_FILING_IN_PROCESS: 'FILING IN PROCESS',
  UNLOADING_FILE_READY: 'UNLOADING FILE READY',
  UNLOADING_FILED: 'UNLOADING FILED',
  UNLOADING_FILED_FAILED: 'ULOADING FILE FAILED',
  UNLOADING_FILED_REJECTED: 'UNLOADING FILED REJECTED,',
  UNLOADING_CANCELLATION_FILED: 'CANCEL FILED',
  UNLOADING_ACCEPTED: 'UNLOADING ACCEPTED',
  UNLOADING_FILED_ACKNOWLEDGED: 'UNLOADING FILED ACKNOWLEDGED',
  UNOADING_NEW: 'UNOADING NEW',

  NCTS_NONE: 'NCTS NONE',
  DECLARATION_DATA_MESSAGE: 'DECLARATION DATA MESSAGE',
  DECLARATION_DATA_REJECTED: 'DECLARATION DATA REJECTED',
  POSITIVE_ACKNOWLEDGEMENT_MESSAGE: 'POSITIVE ACKNOWLEDGEMENT MESSAGE',
  MRN_ALLOCATED: 'MRN ALLOCATED',
  GUARANTEE_NOT_VALID: 'GUARANTEE NOT VALID',
  CONTROL_DECISION_NOTIFICATION: 'CONTROL DECISION NOTIFICATION',
  RELEASE_FOR_TRANSIT: 'RELEASE FOR TRANSIT',
  NO_RELEASE_FOR_TRANSIT: 'NO RELEASE FOR TRANSIT',
  ARRIVAL_NOTIFICATION_MESSAGE: 'ARRIVAL NOTIFICATION MESSAGE',
  ARRIVAL_NOTIFICATION_REJECTION: 'ARRIVAL NOTIFICATION REJECTION',
  DECLARATION_CANCELLATION_REQUEST: 'DECLARATION CANCELLATION REQUEST',
  UNLOADING_PERMISSION: 'UNLOADING PERMISSION',
  UNLOADING_REMARKS: 'UNLOADING REMARKS',
  CANCELLATION_DECISION_MESSAGE: 'CANCELLATION DECISION MESSAGE',
  UNLOADING_REMARKS_REJECTION: 'UNLOADING REMARKS REJECTION',
  GOODS_RELEASE_NOTIFICATION: 'GOODS RELEASE NOTIFICATION',
  GOODS_MOVEMENT_COMPLETE: 'GOODS MOVEMENT COMPLETE',
  TRANSIT_ARRIVAL_FILED_REJECTED: 'TRANSIT ARRIVAL FILED REJECTED',
  TRANSIT_ARRIVAL_FILED_ACKNOWLEDGED: 'TRANSIT ARRIVAL FILED ACKNOWLEDGED',
  TRANSIT_COMPLETE: 'TRANSIT COMPLETE',
  TRANSIT_FILED_REJECTED: 'TRANSIT FILED REJECTED',
  TRANSIT_CANCELLATION_ACCEPTED: 'TRANSIT CANCELLATION ACCEPTED',
  TRANSIT_ARRIVAL_IN_PROCESS: 'TRANSIT ARRIVAL IN PROCESS',
  TRANSIT_UNLOAD_IN_PROCESS: 'TRANSIT UNLOAD IN PROCESS',
  TRANSIT_UNLOAD_READY_TO_FILED: 'TRANSIT UNLOAD READY TO FILED',

}

const ESTextMapper = {
  ENTRY_NONE: "PENDING FILING",
  ENTRY_IN_PROCESS: "ENTRY IN PROCESS",
  ENTRY_STUCK: "ENTRY STUCK",
  ENTRY_ON_HOLD: "ENTRY ON HOLD",
  ENTRY_READY: "ENTRY READY",
  ENTRY_FILED: "ENTRY FILED",
  ENTRY_ACCEPTED: "ENTRY ACCEPTED",
  ENTRY_REJECTED: "ENTRY REJECTED",
  ENTRY_CLEARED: "ENTRY CLEARED",
  ENTRY_AMEND_IN_PROCESS: "ENTRY AMEND IN PROCESS",
  ENTRY_AMEND_READY: "ENTRY AMEND READY",
  ENTRY_AMEND_FILED: "ENTRY AMEND FILED",
  ENTRY_AMEND_ACCEPTED: "ENTRY AMEND ACCEPTED",
  ENTRY_AMEND_FAILED: "ENTRY AMEND FAILED",
  ENTRY_AMEND_REJECTED: "ENTRY AMEND REJECTED",
  CANCEL_FILED: "ENTRY CANCEL FILED",
  CANCEL_FILED_FAILED: "ENTRY CANCEL REJECTED",
  ENTRY_CANCELLED_FILED: "ENTRY CANCEL FILED",
  ENTRY_CANCELLED_FAILED: "ENTRY CANCELLED FAILED",
  ENTRY_CANCELLED: "ENTRY CANCELLED",
  ENTRY_RELEASED: "ENTRY RELEASED",
  ENTRY_COMPLETED: "ENTRY COMPLETED",
  ENTRY_FROZEN: "ENTRY FROZEN",
  ENTRY_GOODS_EXITED: "ENTRY GOODS EXITED",
  ENTRY_SUP_IN_PROCESS: "ENTRY SUPPLEMENT IN PROCESS",
  ENTRY_SUP_READY: "ENTRY SUPPLEMENT READY",
  ENTRY_SUP_FILED: "ENTRY SUPPLEMENT FILED",
  ENTRY_SUP_ACCEPTED: "ENTRY SUPPLEMENT ACCEPTED",
  ENTRY_SUP_FAILED: "ENTRY SUPPLEMENT FAILED",
  ENTRY_SUP_REJECTED: "ENTRY SUPPLEMENT REJECTED",

  ENTRY_EXT_IN_PROCESS: "ENTRY EXIT INFO IN PROCESS",
  ENTRY_EXT_READY: "ENTRY EXIT INFO READY",
  ENTRY_EXT_FILED: "ENTRY EXIT INFO FILED",
  ENTRY_EXT_ACCEPTED: "ENTRY EXIT INFO ACCEPTED",
  ENTRY_EXT_FAILED: "ENTRY EXIT INFO FAILED",
  ENTRY_EXT_REJECTED: "ENTRY EXIT INFO REJECTED"
}

const ESCustomsTextMapper = {
  CUSTOMS_NONE: "PENDING FILING",
  CUSTOM_NONE: "PENDING FILING",
  PDI_NEW: "PDI NEW",
  PDI_FILED: "PDI FILED",
  PDI_FILED_FAILED: "PDI FILED FAILED",
  PDI_CANCELLED_FILED: "PDI CANCELLED FILED",
  PDI_CANCELLED_FILED_FAILED: "PDI CANCELLED FILED FAILED",
  PDI_ACCEPTED: "PDI ACCEPTED",
  PDI_AMEND_FILED: "PDI AMEND FILED",
  PDI_AMEND_FAILED: "PDI AMEND FAILED",
  PDI_AMEND_ACCEPTED: "PDI AMEND ACCEPTED",
  PDC_NEW: "PDC NEW",
  PDC_FILED: "PDC FILED",
  PDC_FILED_FAILED: "PDC FILED FAILED",
  CANCEL_FILED: "CANCEL FILED",
  CANCEL_FILED_FAILED: "CANCEL FILED FAILED",
  CANCELLED: "CANCEL ACCEPTED",
  CANCEL_ACCEPTED: "CANCEL ACCEPTED",
  PDC_ACCEPTED: "PDC ACCEPTED",
  PDC_AMEND_NEW: "PDC AMEND NEW",
  PDC_AMEND_FILED: "PDC AMEND FILED",
  PDC_AMEND_FAILED: "PDC AMEND FAILED",
  FULL_SAD_NEW: "FULL SAD NEW",
  FULL_SAD_FILED: "FULL SAD FILED",
  FULL_SAD_ACCEPTED: "FULL SAD ACCEPTED",
  FULL_SAD_AMEND_FILED: "FULL SAD AMEND FILED",
  FULL_SAD_FAILED: "FULL SAD FAILED",
  BOX_40_REQUIRED: "BOX 40 REQUIRED",
  BOX_40_FILED: "BOX 40 FILED",
  BOX_40_FAILED: "BOX 40 FAILED",
  BOX_40_ACCEPTED: "BOX 40 ACCEPTED",
  BOX_44_REQUIRED: "BOX 44 REQUIRED",
  BOX_44_FILED: "BOX 44 FILED",
  BOX_44_FAILED: "BOX 44 FAILED",
  BOX_44_ACCEPTED: "BOX 44 ACCEPTED",
  CLEAR: "CLEAR",
  RELEASED: "RELEASED",
  TYPE_A_NEW: "TYPE A NEW",
  TYPE_A_FILED: "TYPE A FILED",
  TYPE_A_FILED_FAILED: "TYPE A FILED FAILED",
  TYPE_A_ACCEPTED: "TYPE A ACCEPTED",
  TYPE_A_AMEND_NEW: "TYPE A AMEND NEW",
  TYPE_A_AMEND_FILED: "TYPE A AMEND FILED",
  TYPE_A_AMEND_FAILED: "TYPE A AMEND FAILED",
  TYPE_A_AMEND_ACCEPTED: "TYPE A AMEND ACCEPTED",
  TYPE_B_NEW: "TYPE B NEW",
  TYPE_B_FILED: "TYPE B FILED",
  TYPE_B_FILED_FAILED: "TYPE B FILED FAILED",
  TYPE_B_ACCEPTED: "TYPE B ACCEPTED",
  TYPE_B_AMEND_NEW: "TYPE B AMEND NEW",
  TYPE_B_AMEND_FILED: "TYPE B AMEND FILED",
  TYPE_B_AMEND_FAILED: "TYPE B AMEND FAILED",
  TYPE_B_AMEND_ACCEPTED: "TYPE B AMEND ACCEPTED",
  TYPE_C_NEW: "TYPE C NEW",
  TYPE_C_FILED: "TYPE C FILED",
  TYPE_C_FILED_FAILED: "TYPE C FILED FAILED",
  TYPE_C_ACCEPTED: "TYPE C ACCEPTED",
  TYPE_C_AMEND_NEW: "TYPE C AMEND NEW",
  TYPE_C_AMEND_FILED: "TYPE C AMEND FILED",
  TYPE_C_AMEND_FAILED: "TYPE C AMEND FAILED",
  TYPE_C_AMEND_ACCEPTED: "TYPE C AMEND ACCEPTED",
  TYPE_D_NEW: "TYPE D NEW",
  TYPE_D_FILED: "TYPE D FILED",
  TYPE_D_FILED_FAILED: "TYPE D FILED FAILED",
  TYPE_D_ACCEPTED: "TYPE D ACCEPTED",
  TYPE_PRE_NEW: "TYPE PRE NEW",
  TYPE_PRE_FILED: "TYPE PRE FILED",
  TYPE_PRE_FILED_FAILED: "TYPE PRE FILED FAILED",
  TYPE_PRE_ACCEPTED: "TYPE PRE ACCEPTED",
  TYPE_CER_NEW: "TYPE CER NEW",
  TYPE_CER_FILED: "TYPE CER FILED",
  TYPE_CER_FAILED: "TYPE_CER_FAILED",
  TYPE_CER_FILED_FAILED: "TYPE CER FILED FAILED",
  TYPE_CER_ACCEPTED: "TYPE CER ACCEPTED",
  TYPE_D_AMEND_NEW: "TYPE D AMEND NEW",
  TYPE_D_AMEND_FILED: "TYPE D AMEND FILED",
  TYPE_D_AMEND_FAILED: "TYPE D AMEND FAILED",
  TYPE_D_AMEND_ACCEPTED: "TYPE D AMEND ACCEPTED",
  TYPE_X_NEW: "TYPE X NEW",
  TYPE_X_FILED: "TYPE X FILED",
  TYPE_X_FILED_FAILED: "TYPE X FILED FAILED",
  TYPE_X_ACCEPTED: "TYPE X ACCEPTED",
  TYPE_Y_NEW: "TYPE Y NEW",
  TYPE_Y_FILED: "TYPE Y FILED",
  TYPE_Y_FILED_FAILED: "TYPE Y FILED FAILED",
  TYPE_Y_ACCEPTED: "TYPE Y ACCEPTED",
  TYPE_DOC_NEW: "TYPE DOC NEW",
  TYPE_DOC_FILED: "TYPE DOC FILED",
  TYPE_DOC_FAILED: "TYPE DOC FAILED",
  TYPE_DOC_ACCEPTED: "TYPE DOC ACCEPTED",
  TYPE_NOT_NEW: "TYPE NOT NEW",
  TYPE_NOT_FILED: "TYPE NOT FILED",
  TYPE_NOT_FAILED: "TYPE NOT FAILED",
  TYPE_NOT_ACCEPTED: "TYPE NOT ACCEPTED"
}

const CDSCustomMapper = {
  CDS_NONE: "PENDING FILING",
  CUSTOM_NONE: "PENDING FILING",
  CUSTOMS_NONE: "PENDING FILING",
  DMSACC: "DEC REGISTERED/ACCEPTED",
  DMSREJ: "DECLARATION REJECTED",
  DMSALV: "DMSALV",
  DMSCTL: "PHYSICALLY EXAMINE",
  DMSRES: "CORRECTION APPLIED",
  DMSROG: "GOODS RELEASED",
  DMSCLE: "CLEARED",
  DMSINV: "DEC INVALIDATED",
  DMSREQ: "ADDITIONAL MESSAGE",
  DMSTAX: "TAX VERIFICATION",
  DMSCPI: "INSUFFICIENT BALANCE",
  DMSCPR: "PAYMENT REQUIRED",
  DMSEOG: "GOODS EXITED",
  DMSDOC: "DOCUMENT REQUIRED",
  DMSQRY: "HMRC QUERY"
}

const NLCustomsMapper = {
  DMSCRE: "DECLARATION CREATED",
  DMSACK: "DECLARATION ACKNOWLEDGED",
  DMSSENT: "DECLARATION SENT",
  CONTRL: "TECHNICAL ERRORS",
  DMSREJ: "DECLARATION REJECTED",
  DMSACC: "DECLARATION ACCEPTED",  // 01
  DMSDOC: "DOCUMENTS CONTROL",
  DMSCTL: "PHYSICAL INSPECTION", // 05
  DMSROG: "PROVISIONALLY RELEASED", // Sub can be field after DMSROG
  DMSRES: "ENTRY ADJUSTED",
  DMSCLE: "FINAL RELEASE",
  DMSRCV: "DECLARATION RECEIVED",
  //DMSREQ: "DECLARATION DECISION",

  ALTSENT: "EXIT INFO SENT",
  ALTREM: "SEND EXIT INFO REMINDER",
  ALTACK: "EXIT ACKNOWLEDGED",
  ALTREJ: "EXIT INFO REJECTED",
  ALTRCV: "EXIT INFO RECIEVED",
  ALTREQ: "EXIT INFO DECISION",
  DMSEOG: "EXIT CONFIRMATION", // Can come after DMSCLE, DMSROG, CORRES [FINAL STATE]
  DMSGER: "SEND EXIT INFO REQUIRED",
  DMSINV: "DECLARATION CANCELLED", //


  CORSENT: "AMENDMENT REQUEST SENT",
  CORACK: "AMENDMENT ACKNOWLEDGED",
  CORREJ: "AMENDMENT REJECTED",
  CORRCV: "AMENDMENT RECEIVED",
  CORREQ: "AMENDMENT DECISION",
  CORRES: "AMENDMENT FINALIZED",

  INVSENT: "CANCEL REQUEST SENT",
  INVACK: "CANCEL ACKNOWLEDGED",
  INVREJ: "CANCELLATION REJECTED",
  INVRCV: "CANCELLATION RECEIVED",
  DMSINV: "DECLARATION CANCELLED", // Can't do anything after DMSINV  
  INVREQ: "CANCELLATION DECISION",

  DMSINC: "SUPPLEMENT REQUIRED",
  SUPSENT: "SUPPLEMENT SENT",
  SUPACK: "SUPPLEMENT ACKNOWLEDGED",
  SUPRCV: "SUPPLEMENT RECIEVED",
  SUPREQ: "SUPPLEMENT DECISION",
  SUPRES: "SUPPLEMENT FINALIZED",
  SUPREJ: "SUPPLEMENT REJECTED",
  SUPREM: "SUPPLEMENT REMINDER",
  EXT: "EXTERNAL HANDLING",
  DMSEXT: "EXTERNAL HANDLING", // Can't do any thing after EXT

}

export const statusClass = {
  WARNING: "warning",
  POSITIVE: "positive",
  ERROR: "error",
  NEUTRAL: "neutral",
  HARD_WARNING:"orange",
  BLOCK_LABEL: "block",
  ON_HOLD: "onHold",
  PSC_NEUTRAL: 'psc_neutral',
  NCTS_NEUTRAL: 'psc_neutral'
}
const transitMapper = {
  STATE_TRANSIT_NONE: { text: nctsTextMapper.TRANSIT_NONE, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_NEW: { text: nctsTextMapper.TRANSIT_NEW, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_PENDING: { text: nctsTextMapper.TRANSIT_PENDING, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_IN_PROCESS: { text: nctsTextMapper.TRANSIT_IN_PROCESS, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_FILING_IN_PROCESS: { text: nctsTextMapper.TRANSIT_FILING_IN_PROCESS, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_READY_TO_FILE: { text: nctsTextMapper.TRANSIT_FILE_READY, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_FILED: { text: nctsTextMapper.TRANSIT_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_FILED_FAILED: { text: nctsTextMapper.TRANSIT_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_FILED_REJECTED: { text: nctsTextMapper.TRANSIT_FILED_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_FILED_ACKNOWLEDGED: { text: nctsTextMapper.TRANSIT_FILED_ACKNOWLEDGED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_DECLARATION_FAILED: { text: nctsTextMapper.TRANSIT_DECLARATION_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_CANCELLATION_FILED: { text: nctsTextMapper.TRANSIT_CANCELLATION_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_CANCELLATION_FILED_FAILED: { text: nctsTextMapper.TRANSIT_CANCELLATION_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_FILED_REJECTED: { text: nctsTextMapper.ARRIVAL_FILED_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_CANCELLATION_ACCEPTED: { text: nctsTextMapper.TRANSIT_CANCELLATION_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ACCEPTED: { text: nctsTextMapper.TRANSIT_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_COMPLETE: { text: nctsTextMapper.TRANSIT_COMPLETE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_SKIPPED: { text: nctsTextMapper.TRANSIT_SKIPPED, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_IN_PROCESS: { text: nctsTextMapper.ARRIVAL_IN_PROCESS, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_FILING_IN_PROCESS: { text: nctsTextMapper.ARRIVAL_FILING_IN_PROCESS, class: `${statusClass.PSC_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_READY_TO_FILED: { text: nctsTextMapper.ARRIVAL_FILE_READY, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_FILED: { text: nctsTextMapper.ARRIVAL_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_FILED_FAILED: { text: nctsTextMapper.ARRIVAL_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_FILED_ACKNOWLEDGED: { text: nctsTextMapper.ARRIVAL_FILED_ACKNOWLEDGED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_CANCELLATION_FILED: { text: nctsTextMapper.ARRIVAL_CANCELLATION_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_ARRIVAL_ACCEPTED: { text: nctsTextMapper.ARRIVAL_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TRANSIT_UNLOAD_IN_PROCESS: { text: nctsTextMapper.UNLOADING_IN_PROCESS, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_FILING_IN_PROCESS: { text: nctsTextMapper.UNLOADING_FILING_IN_PROCESS, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_READY_TO_FILED: { text: nctsTextMapper.UNLOADING_FILE_READY, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_FILED: { text: nctsTextMapper.UNLOADING_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_FILED_ACKNOWLEDGED: { text: nctsTextMapper.UNLOADING_FILED_ACKNOWLEDGED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_FILED_FAILED: { text: nctsTextMapper.UNLOADING_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_FILED_REJECTED: { text: nctsTextMapper.UNLOADING_FILED_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_CANCELLATION_FILED: { text: nctsTextMapper.UNLOADING_CANCELLATION_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_ACCEPTED: { text: nctsTextMapper.UNLOADING_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_UNLOAD_NEW: { text: nctsTextMapper.UNOADING_NEW, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },

}

const nctsMapper = {
  STATE_NCTS_NONE: { text: nctsTextMapper.NCTS_NONE, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DECLARATION_DATA_MESSAGE: { text: nctsTextMapper.DECLARATION_DATA_MESSAGE, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DECLARATION_DATA_REJECTED: { text: nctsTextMapper.DECLARATION_DATA_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_POSITIVE_ACKNOWLEDGEMENT_MESSAGE: { text: nctsTextMapper.POSITIVE_ACKNOWLEDGEMENT_MESSAGE, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_MRN_ALLOCATED: { text: nctsTextMapper.MRN_ALLOCATED, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_GUARANTEE_NOT_VALID: { text: nctsTextMapper.GUARANTEE_NOT_VALID, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_CONTROL_DECISION_NOTIFICATION: { text: nctsTextMapper.CONTROL_DECISION_NOTIFICATION, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_RELEASE_FOR_TRANSIT: { text: nctsTextMapper.RELEASE_FOR_TRANSIT, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_NO_RELEASE_FOR_TRANSIT: { text: nctsTextMapper.NO_RELEASE_FOR_TRANSIT, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ARRIVAL_NOTIFICATION_MESSAGE: { text: nctsTextMapper.ARRIVAL_NOTIFICATION_MESSAGE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ARRIVAL_NOTIFICATION_REJECTION: { text: nctsTextMapper.ARRIVAL_NOTIFICATION_REJECTION, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DECLARATION_CANCELLATION_REQUEST: { text: nctsTextMapper.DECLARATION_CANCELLATION_REQUEST, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_UNLOADING_PERMISSION: { text: nctsTextMapper.UNLOADING_PERMISSION, class: `${statusClass.NCTS_NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_UNLOADING_REMARKS: { text: nctsTextMapper.UNLOADING_REMARKS, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_CANCELLATION_DECISION_MESSAGE: { text: nctsTextMapper.CANCELLATION_DECISION_MESSAGE, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_UNLOADING_REMARKS_REJECTION: { text: nctsTextMapper.UNLOADING_REMARKS_REJECTION, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_GOODS_RELEASE_NOTIFICATION: { text: nctsTextMapper.GOODS_RELEASE_NOTIFICATION, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_GOODS_MOVEMENT_COMPLETE: { text: nctsTextMapper.GOODS_MOVEMENT_COMPLETE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TRANSIT_COMPLETE: { text: nctsTextMapper.TRANSIT_COMPLETE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
}



const ES_Mapper = {
  STATE_ENTRY_NONE: { text: ESTextMapper.ENTRY_NONE, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_IN_PROCESS: { text: ESTextMapper.ENTRY_IN_PROCESS, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_STUCK: { text: ESTextMapper.ENTRY_STUCK, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_ON_HOLD: { text: ESTextMapper.ENTRY_ON_HOLD, class: `${statusClass.ON_HOLD} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_READY: { text: ESTextMapper.ENTRY_READY, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_FILED: { text: ESTextMapper.ENTRY_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_CANCELLED_FILED: { text: ESTextMapper.CANCEL_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_CANCELLED_FAILED: { text: ESTextMapper.ENTRY_CANCELLED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_CANCELLED: { text: ESTextMapper.ENTRY_CANCELLED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_RELEASED: { text: ESTextMapper.ENTRY_RELEASED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_COMPLETED: { text: ESTextMapper.ENTRY_COMPLETED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_ACCEPTED: { text: ESTextMapper.ENTRY_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_CLEARED: { text: ESTextMapper.ENTRY_CLEARED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_REJECTED: { text: ESTextMapper.ENTRY_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_FROZEN: { text: ESTextMapper.ENTRY_FROZEN, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_GOODS_EXITED: { text: ESTextMapper.ENTRY_GOODS_EXITED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_IN_PROCESS: { text: ESTextMapper.ENTRY_AMEND_IN_PROCESS, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_READY: { text: ESTextMapper.ENTRY_AMEND_READY, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_FILED: { text: ESTextMapper.ENTRY_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_ACCEPTED: { text: ESTextMapper.ENTRY_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_REJECTED: { text: ESTextMapper.ENTRY_AMEND_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_AMEND_FAILED: { text: ESTextMapper.ENTRY_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },

  STATE_ENTRY_SUP_IN_PROCESS: { text: ESTextMapper.ENTRY_SUP_IN_PROCESS, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_SUP_READY: { text: ESTextMapper.ENTRY_SUP_READY, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_SUP_FILED: { text: ESTextMapper.ENTRY_SUP_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_SUP_ACCEPTED: { text: ESTextMapper.ENTRY_SUP_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_SUP_REJECTED: { text: ESTextMapper.ENTRY_SUP_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_SUP_FAILED: { text: ESTextMapper.ENTRY_SUP_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },

  STATE_ENTRY_EXT_IN_PROCESS: { text: ESTextMapper.ENTRY_EXT_IN_PROCESS, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_EXT_READY: { text: ESTextMapper.ENTRY_EXT_READY, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_EXT_FILED: { text: ESTextMapper.ENTRY_EXT_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_EXT_ACCEPTED: { text: ESTextMapper.ENTRY_EXT_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_EXT_REJECTED: { text: ESTextMapper.ENTRY_EXT_REJECTED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ENTRY_EXT_FAILED: { text: ESTextMapper.ENTRY_EXT_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` }

}

const CDS_CustomsMapper = {
  STATE_CDS_NONE: { text: CDSCustomMapper.CDS_NONE, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CUSTOMS_NONE: { text: CDSCustomMapper.CUSTOM_NONE, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSACC: { text: CDSCustomMapper.DMSACC, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSREJ: { text: CDSCustomMapper.DMSREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSALV: { text: CDSCustomMapper.DMSALV, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSDOC: { text: CDSCustomMapper.DMSDOC, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSQRY: { text: CDSCustomMapper.DMSQRY, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCTL: { text: CDSCustomMapper.DMSCTL, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSRES: { text: CDSCustomMapper.DMSRES, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSROG: { text: CDSCustomMapper.DMSROG, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCLE: { text: CDSCustomMapper.DMSCLE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSINV: { text: CDSCustomMapper.DMSINV, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSREQ: { text: CDSCustomMapper.DMSREQ, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSTAX: { text: CDSCustomMapper.DMSTAX, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCPI: { text: CDSCustomMapper.DMSCPI, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCPR: { text: CDSCustomMapper.DMSCPR, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSEOG: { text: CDSCustomMapper.DMSEOG, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` }
}

const ES_CustomsMapper = {
  STATE_CUSTOMS_NONE: { text: ESCustomsTextMapper.CUSTOMS_NONE, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_NEW: { text: ESCustomsTextMapper.PDI_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_FILED: { text: ESCustomsTextMapper.PDI_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_FILED_FAILED: { text: ESCustomsTextMapper.PDI_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_ACCEPTED: { text: ESCustomsTextMapper.PDI_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_AMEND_FILED: { text: ESCustomsTextMapper.PDI_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_AMEND_FAILED: { text: ESCustomsTextMapper.PDI_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_AMEND_ACCEPTED: { text: ESCustomsTextMapper.PDI_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_CANCELLED_FILED: { text: ESCustomsTextMapper.PDI_CANCELLED_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_PDI_CANCELLED_FILED_FAILED: { text: ESCustomsTextMapper.PDI_CANCELLED_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },

  STATE_PDC_NEW: { text: ESCustomsTextMapper.PDC_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_FILED: { text: ESCustomsTextMapper.PDC_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_FILED_FAILED: { text: ESCustomsTextMapper.PDC_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_ACCEPTED: { text: ESCustomsTextMapper.PDC_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_AMEND_NEW: { text: ESCustomsTextMapper.PDC_AMEND_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_AMEND_FILED: { text: ESCustomsTextMapper.PDC_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_PDC_AMEND_FAILED: { text: ESCustomsTextMapper.PDC_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_NEW: { text: ESCustomsTextMapper.FULL_SAD_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_FILED: { text: ESCustomsTextMapper.FULL_SAD_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_ACCEPTED: { text: ESCustomsTextMapper.FULL_SAD_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_AMEND_FILED: { text: ESCustomsTextMapper.FULL_SAD_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_FAILED: { text: ESCustomsTextMapper.FULL_SAD_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_CANCELLED_FILED: { text: ESCustomsTextMapper.FULL_SAD_CANCELLED_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_FULL_SAD_CANCELLED_FILED_FAILED: { text: ESCustomsTextMapper.FULL_SAD_CANCELLED_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_40_REQUIRED: { text: ESCustomsTextMapper.BOX_40_REQUIRED, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_40_FILED: { text: ESCustomsTextMapper.BOX_40_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_40_FAILED: { text: ESCustomsTextMapper.BOX_40_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_40_ACCEPTED: { text: ESCustomsTextMapper.BOX_40_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_44_REQUIRED: { text: ESCustomsTextMapper.BOX_44_REQUIRED, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_44_FILED: { text: ESCustomsTextMapper.BOX_44_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_44_FAILED: { text: ESCustomsTextMapper.BOX_44_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_BOX_44_ACCEPTED: { text: ESCustomsTextMapper.BOX_44_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_RELEASED: { text: ESCustomsTextMapper.RELEASED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_CLEAR: { text: ESCustomsTextMapper.CLEAR, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_CANCEL_FILED: { text: ESCustomsTextMapper.CANCEL_FILED, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_CANCEL_FAILED: { text: ESCustomsTextMapper.CANCEL_FILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_CANCEL_FILED_FAILED: { text: ESCustomsTextMapper.CANCEL_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_CANCEL_ACCEPTED: { text: ESCustomsTextMapper.CANCELLED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_A_NEW: { text: ESCustomsTextMapper.TYPE_A_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_FILED: { text: ESCustomsTextMapper.TYPE_A_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_A_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_ACCEPTED: { text: ESCustomsTextMapper.TYPE_A_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_AMEND_NEW: { text: ESCustomsTextMapper.TYPE_A_AMEND_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_AMEND_FILED: { text: ESCustomsTextMapper.TYPE_A_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_AMEND_FAILED: { text: ESCustomsTextMapper.TYPE_A_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_A_AMEND_ACCEPTED: { text: ESCustomsTextMapper.TYPE_A_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_B_NEW: { text: ESCustomsTextMapper.TYPE_B_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_FILED: { text: ESCustomsTextMapper.TYPE_B_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_B_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_ACCEPTED: { text: ESCustomsTextMapper.TYPE_B_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_AMEND_NEW: { text: ESCustomsTextMapper.TYPE_B_AMEND_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_AMEND_FILED: { text: ESCustomsTextMapper.TYPE_B_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_AMEND_FAILED: { text: ESCustomsTextMapper.TYPE_B_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_B_AMEND_ACCEPTED: { text: ESCustomsTextMapper.TYPE_B_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_C_NEW: { text: ESCustomsTextMapper.TYPE_C_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_FILED: { text: ESCustomsTextMapper.TYPE_C_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_C_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_ACCEPTED: { text: ESCustomsTextMapper.TYPE_C_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_AMEND_NEW: { text: ESCustomsTextMapper.TYPE_C_AMEND_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_AMEND_FILED: { text: ESCustomsTextMapper.TYPE_C_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_AMEND_FAILED: { text: ESCustomsTextMapper.TYPE_C_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_C_AMEND_ACCEPTED: { text: ESCustomsTextMapper.TYPE_C_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_D_NEW: { text: ESCustomsTextMapper.TYPE_D_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_FILED: { text: ESCustomsTextMapper.TYPE_D_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_D_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_ACCEPTED: { text: ESCustomsTextMapper.TYPE_D_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_AMEND_NEW: { text: ESCustomsTextMapper.TYPE_D_AMEND_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_AMEND_FILED: { text: ESCustomsTextMapper.TYPE_D_AMEND_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_AMEND_FAILED: { text: ESCustomsTextMapper.TYPE_D_AMEND_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_D_AMEND_ACCEPTED: { text: ESCustomsTextMapper.TYPE_D_AMEND_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_PRE_NEW: { text: ESCustomsTextMapper.TYPE_PRE_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_PRE_FILED: { text: ESCustomsTextMapper.TYPE_PRE_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_PRE_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_PRE_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_PRE_ACCEPTED: { text: ESCustomsTextMapper.TYPE_PRE_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_CER_NEW: { text: ESCustomsTextMapper.TYPE_CER_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_CER_FILED: { text: ESCustomsTextMapper.TYPE_CER_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_CER_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_CER_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_CER_FAILED: { text: ESCustomsTextMapper.TYPE_CER_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_CER_ACCEPTED: { text: ESCustomsTextMapper.TYPE_CER_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },


  STATE_TYPE_X_NEW: { text: ESCustomsTextMapper.TYPE_X_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_X_FILED: { text: ESCustomsTextMapper.TYPE_X_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_X_FAILED: { text: ESCustomsTextMapper.TYPE_X_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_X_ACCEPTED: { text: ESCustomsTextMapper.TYPE_X_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_Y_NEW: { text: ESCustomsTextMapper.TYPE_Y_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_Y_FILED: { text: ESCustomsTextMapper.TYPE_Y_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_Y_FILED_FAILED: { text: ESCustomsTextMapper.TYPE_Y_FILED_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_Y_ACCEPTED: { text: ESCustomsTextMapper.TYPE_Y_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_DOC_NEW: { text: ESCustomsTextMapper.TYPE_DOC_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_DOC_FILED: { text: ESCustomsTextMapper.TYPE_DOC_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_DOC_FAILED: { text: ESCustomsTextMapper.TYPE_DOC_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_DOC_ACCEPTED: { text: ESCustomsTextMapper.TYPE_DOC_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_TYPE_NOT_NEW: { text: ESCustomsTextMapper.TYPE_NOT_NEW, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_NOT_FILED: { text: ESCustomsTextMapper.TYPE_NOT_FILED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_NOT_FAILED: { text: ESCustomsTextMapper.TYPE_NOT_FAILED, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_TYPE_NOT_ACCEPTED: { text: ESCustomsTextMapper.TYPE_NOT_ACCEPTED, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

}

const NL_CustomsMapper = {
  STATE_DMSCRE: { text: NLCustomsMapper.DMSCRE, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSACK: { text: NLCustomsMapper.DMSACK, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSSENT: { text: NLCustomsMapper.DMSSENT, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CONTRL: { text: NLCustomsMapper.CONTRL, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSREJ: { text: NLCustomsMapper.DMSREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSACC: { text: NLCustomsMapper.DMSACC, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSDOC: { text: NLCustomsMapper.DMSDOC, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCTL: { text: NLCustomsMapper.DMSCTL, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSROG: { text: NLCustomsMapper.DMSROG, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSRES: { text: NLCustomsMapper.DMSRES, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSCLE: { text: NLCustomsMapper.DMSCLE, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSRCV: { text: NLCustomsMapper.DMSRCV, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_ALTREM: { text: NLCustomsMapper.ALTREM, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_ALTSENT: { text: NLCustomsMapper.ALTSENT, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ALTACK: { text: NLCustomsMapper.ALTACK, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ALTREJ: { text: NLCustomsMapper.ALTREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_ALTRCV: { text: NLCustomsMapper.ALTRCV, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_ALTREQ: { text: NLCustomsMapper.ALTREQ, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSGER: { text: NLCustomsMapper.DMSGER, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },


  STATE_DMSEOG: { text: NLCustomsMapper.DMSEOG, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSINV: { text: NLCustomsMapper.DMSINV, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_DMSINC: { text: NLCustomsMapper.DMSINC, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },

  STATE_DMSEXT: { text: NLCustomsMapper.DMSEXT, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
  STATE_EXT: { text: NLCustomsMapper.DMSEXT, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },

  STATE_CORSENT: { text: NLCustomsMapper.CORSENT, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CORACK: { text: NLCustomsMapper.CORACK, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CORREJ: { text: NLCustomsMapper.CORREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_CORRCV: { text: NLCustomsMapper.CORRCV, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CORREQ: { text: NLCustomsMapper.CORREQ, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_CORRES: { text: NLCustomsMapper.CORRES, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },

  STATE_INVSENT: { text: NLCustomsMapper.INVSENT, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_INVACK: { text: NLCustomsMapper.INVACK, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_INVREJ: { text: NLCustomsMapper.INVREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_INVRCV: { text: NLCustomsMapper.INVRCV, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_INVREQ: { text: NLCustomsMapper.INVREQ, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },

  STATE_SUPSENT: { text: NLCustomsMapper.SUPSENT, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPACK: { text: NLCustomsMapper.SUPACK, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPRCV: { text: NLCustomsMapper.SUPRCV, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPREQ: { text: NLCustomsMapper.SUPREQ, class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPRES: { text: NLCustomsMapper.SUPRES, class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPREJ: { text: NLCustomsMapper.SUPREJ, class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}` },
  STATE_SUPREM: { text: NLCustomsMapper.SUPREM, class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}` },
}

const pscMapper = {
  US: {
    STATE_PSC_ACCEPTED_WITH_WARNING: {
      text: pscTextMapper.STATE_PSC_ACCEPTED_WITH_WARNING,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_NONE: {
      text: pscTextMapper.PSC_NONE,
      class: `${statusClass.PSC_NEUTRAL} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_NEW: {
      text: pscTextMapper.PSC_STARTED,
      class: `${statusClass.PSC_NEUTRAL} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_IN_PROCESS: {
      text: pscTextMapper.PSC_IN_PROCESS,
      class: `${statusClass.PSC_NEUTRAL} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_READY: {
      text: pscTextMapper.PSC_READY,
      class: `${statusClass.PSC_NEUTRAL} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_FILED: {
      text: pscTextMapper.PSC_FILED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_ACCEPTED: {
      text: pscTextMapper.PSC_ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_REJECTED: {
      text: pscTextMapper.PSC_REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_PSC_CANCELLED: {
      text: pscTextMapper.PSC_CANCELLED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
  },
};
const entrySummaryMapper = {
  US: {
    STATE_ENTRY_SUMMARY_NONE: {
      text: statusTextMapper.PENDING,
      class: statusClass.NEUTRAL,
    },
    STATE_ASSIGNED_TO_BROKER: {
      text: statusTextMapper.BROKER_ASSIGNED,
      class: statusClass.NEUTRAL,
    },
    STATE_TRANSIT_ARRIVAL_NOTICE_RECEIVED: {
      text: statusTextMapper.ARRIVAL_NOTICE_RECEIVED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_SUMMARY_FILED: {
      text: statusTextMapper.FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_SUMMARY_RETRACT_FILED: {
      text: statusTextMapper.RETRACT_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_SUMMARY_RETRACT_ACCEPTED: {
      text: statusTextMapper.RETRACT_ACCEPTED,
      class: statusClass.WARNING,
    },
    STATE_ENTRY_SUMMARY_RETRACT_REJECTED: {
      text: statusTextMapper.RETRACT_REJECTED,
      class: statusClass.WARNING,
    },
    STATE_ENTRY_SUMMARY_IN_PROCESS: {
      text: statusTextMapper.IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_SUMMARY_ON_HOLD: {
      text: statusTextMapper.ON_HOLD,
      class: statusClass.ON_HOLD,
    },
    STATE_BROKER_IN_QUEUE: {
      text: statusTextMapper.IN_QUEUE,
      class: statusClass.NEUTRAL,
    },
    STATE_CHECKPOINT_FAILED: {
      text: statusTextMapper.CHECKPOINT_FAILED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_SUMMARY_READY: {
      text: statusTextMapper.READY,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_SUMMARY_REJECTED: {
      text: statusTextMapper.REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_SUMMARY_ACCEPTED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS: {
      text: statusTextMapper.ACCEPTED_WARNINGS,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
  },
  GB: {
    // These states will be updated once UK states will be defined
    STATE_ENTRY_NONE: {
      text: statusTextMapper.PENDING,
      class: statusClass.NEUTRAL,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_0: {
      text: statusTextMapper.ROUTE_0,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_1_C: {
      text: statusTextMapper.ROUTE_1_C,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_1: {
      text: statusTextMapper.ROUTE_1,
      class: statusClass.WARNING,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_2: {
      text: statusTextMapper.ROUTE_2,
      class: statusClass.WARNING,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_2_C: {
      text: statusTextMapper.ROUTE_2_C,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_3: {
      text: statusTextMapper.ROUTE_3,
      class: statusClass.WARNING,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_3_C: {
      text: statusTextMapper.ROUTE_3_C,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_5: {
      text: statusTextMapper.ROUTE_5,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_6: {
      text: statusTextMapper.ROUTE_6,
      class: statusClass.WARNING,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_6_C: {
      text: statusTextMapper.ROUTE_6_C,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_E: {
      text: statusTextMapper.ROUTE_E,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_F: {
      text: statusTextMapper.ROUTE_F,
      class: statusClass.POSITIVE,
    },
    STATE_ACCEPTED_ENTRY_ROUTE_H: {
      text: statusTextMapper.ROUTE_H,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_ASSIGNED: {
      text: statusTextMapper.BROKER_ASSIGNED,
      class: statusClass.NEUTRAL,
    },
    STATE_TRANSIT_ARRIVAL_NOTICE_RECEIVED: {
      text: statusTextMapper.ARRIVAL_NOTICE_RECEIVED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_STUCK: {
      text: statusTextMapper.RETRACT_REJECTED,
      class: statusClass.WARNING,
    },
    STATE_ENTRY_FILED: {
      text: statusTextMapper.FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_AMEND_FILED: {
      text: statusTextMapper.AMEND_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_IN_PROCESS: {
      text: statusTextMapper.IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_AMEND_IN_PROCESS: {
      text: statusTextMapper.AMEND_IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_BROKER_IN_QUEUE: {
      text: statusTextMapper.IN_QUEUE,
      class: statusClass.NEUTRAL,
    },
    STATE_CHECKPOINT_FAILED: {
      text: statusTextMapper.CHECKPOINT_FAILED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_ON_HOLD: {
      text: statusTextMapper.ON_HOLD,
      class: statusClass.ON_HOLD,
    },
    STATE_ENTRY_READY: {
      text: statusTextMapper.READY,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_AMEND_READY: {
      text: statusTextMapper.AMEND_READY,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_REJECTED: {
      text: statusTextMapper.REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCEPTED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_AMEND_REJECTED: {
      text: statusTextMapper.AMEND_REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_AMEND_ACCEPTED: {
      text: statusTextMapper.AMEND_ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCEPTED_WITH_WARNINGS: {
      text: statusTextMapper.ACCEPTED_WARNINGS,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_FEC_FAILED: {
      text: statusTextMapper.FEC_FAILED,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CANCEL_FILED: {
      text: statusTextMapper.CANCEL_FILED,
      class: `${statusClass.NEUTRAL} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CANCEL_ACKNOWLEDGED: {
      text: statusTextMapper.CANCEL_ACKNOWLEDGED,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CANCEL_REJECTED: {
      text: statusTextMapper.CANCEL_REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CANCEL_ACCEPTED: {
      text: statusTextMapper.CANCEL_ACCEPTED,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
  },
  CA: {
    STATE_ENTRY_ACCOUNTING_NONE: {
      text: statusTextMapper.PENDING,
      class: statusClass.NEUTRAL,
    },
    STATE_ASSIGNED_TO_BROKER: {
      text: statusTextMapper.BROKER_ASSIGNED,
      class: statusClass.NEUTRAL,
    },
    STATE_TRANSIT_ARRIVAL_NOTICE_RECEIVED: {
      text: statusTextMapper.ARRIVAL_NOTICE_RECEIVED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_ACCOUNTING_FILED: {
      text: statusTextMapper.FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_ACCOUNTING_RETRACT_FILED: {
      text: statusTextMapper.RETRACT_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_ACCOUNTING_IN_PROCESS: {
      text: statusTextMapper.IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_ACCOUNTING_ON_HOLD: {
      text: statusTextMapper.ON_HOLD,
      class: statusClass.ON_HOLD,
    },
    STATE_BROKER_IN_QUEUE: {
      text: statusTextMapper.IN_QUEUE,
      class: statusClass.NEUTRAL,
    },
    STATE_CHECKPOINT_FAILED: {
      text: statusTextMapper.CHECKPOINT_FAILED,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_ACCOUNTING_READY: {
      text: statusTextMapper.READY,
      class: statusClass.NEUTRAL,
    },
    STATE_ENTRY_ACCOUNTING_ACKNOWLEDGED: {
      text: statusTextMapper.ACKNOWLEDGED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCOUNTING_REJECTED: {
      text: statusTextMapper.REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCOUNTING_ACCEPTED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    JOB_STATE_ENTRY_ACCOUNTING_ACCEPTED_WITH_WARNINGS: {
      text: statusTextMapper.ACCEPTED_WARNINGS,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCOUNTING_CANCEL_ACCEPTED:{
      text: statusTextMapper.CANCEL_ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_ENTRY_ACCOUNTING_CANCEL_FILED:{
      text: statusTextMapper.CANCEL_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_ENTRY_ACCOUNTING_CANCEL_REJECTED:{
      text: statusTextMapper.CANCEL_REJECTED,
      class: statusClass.WARNING,
    },
    STATE_ENTRY_ACCOUNTING_AMEND_REJECTED:{
      text:  statusTextMapper.AMEND_REJECTED,
      class: statusClass.ERROR
    },
    STATE_ENTRY_ACCOUNTING_AMEND_IN_PROCESS:{
      text:  statusTextMapper.AMEND_IN_PROCESS,
      class: statusClass.NEUTRAL
    },
    STATE_ENTRY_ACCOUNTING_AMEND_ACCEPTED:{
      text:  statusTextMapper.AMEND_ACCEPTED,
      class: statusClass.POSITIVE
    },
    STATE_ENTRY_ACCOUNTING_AMEND_FILED:{
      text:  statusTextMapper.AMEND_FILED,
      class: statusClass.POSITIVE
    },
    STATE_ENTRY_ACCOUNTING_AMEND_READY:{
      text:  statusTextMapper.AMEND_READY,
      class: statusClass.NEUTRAL
    },
    STATE_ENTRY_ACCOUNTING_APPROVAL_PENDING:{
      text:  statusTextMapper.APPROVAL_PENDING,
      class: statusClass.NEUTRAL
    },
    STATE_ENTRY_ACCOUNTING_AMEND_APPROVAL_PENDING:{
      text:  statusTextMapper.AMEND_APPROVAL_PENDING,
      class: statusClass.NEUTRAL
    },
    
  },
};

const cargoReleaseMapper = {
  US: {
    STATE_CARGO_RELEASE_NONE: {
      text: statusTextMapper.PENDING,
      class: statusClass.NEUTRAL,
    },
    STATE_ASSIGNED_TO_BROKER: {
      text: statusTextMapper.BROKER_ASSIGNED,
      class: statusClass.NEUTRAL,
    },
    STATE_TRANSIT_ARRIVAL_NOTICE_RECEIVED: {
      text: statusTextMapper.ARRIVAL_NOTICE_RECEIVED,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_FILED: {
      text: statusTextMapper.FILED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_RETRACT_FILED: {
      text: statusTextMapper.RETRACT_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_RETRACT_ACCEPTED: {
      text: statusTextMapper.RETRACT_ACCEPTED,
      class: statusClass.WARNING,
    },
    STATE_CARGO_RELEASE_RETRACT_REJECTED: {
      text: statusTextMapper.RETRACT_REJECTED,
      class: statusClass.WARNING,
    },
    STATE_CARGO_RELEASE_IN_PROCESS: {
      text: statusTextMapper.IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_ON_HOLD: {
      text: statusTextMapper.ON_HOLD,
      class: statusClass.ON_HOLD,
    },
    STATE_BROKER_IN_QUEUE: {
      text: statusTextMapper.IN_QUEUE,
      class: statusClass.NEUTRAL,
    },
    STATE_CHECKPOINT_FAILED: {
      text: statusTextMapper.CHECKPOINT_FAILED,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_READY: {
      text: statusTextMapper.READY,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_REJECTED: {
      text: statusTextMapper.REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_ACCEPTED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: {
      text: statusTextMapper.ACCEPTED_WARNINGS,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_SHIPMENT_DELIVERED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
  },
  GB: {},
  CA: {
    STATE_CARGO_RELEASE_NONE: {
      text: statusTextMapper.PENDING,
      class: statusClass.NEUTRAL,
    },
    STATE_ASSIGNED_TO_BROKER: {
      text: statusTextMapper.BROKER_ASSIGNED,
      class: statusClass.NEUTRAL,
    },
    STATE_TRANSIT_ARRIVAL_NOTICE_RECEIVED: {
      text: statusTextMapper.ARRIVAL_NOTICE_RECEIVED,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_FILED: {
      text: statusTextMapper.FILED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_RETRACT_FILED: {
      text: statusTextMapper.RETRACT_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_IN_PROCESS: {
      text: statusTextMapper.IN_PROCESS,
      class: statusClass.NEUTRAL,
    },
    STATE_BROKER_IN_QUEUE: {
      text: statusTextMapper.IN_QUEUE,
      class: statusClass.NEUTRAL,
    },
    STATE_CHECKPOINT_FAILED: {
      text: statusTextMapper.CHECKPOINT_FAILED,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_READY: {
      text: statusTextMapper.READY,
      class: statusClass.NEUTRAL,
    },
    STATE_CARGO_RELEASE_ON_HOLD: {
      text: statusTextMapper.ON_HOLD,
      class: statusClass.ON_HOLD,
    },
    STATE_CARGO_RELEASE_ACKNOWLEDGED: {
      text: statusTextMapper.ACKNOWLEDGED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_REJECTED: {
      text: statusTextMapper.REJECTED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_ACCEPTED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS: {
      text: statusTextMapper.ACCEPTED_WARNINGS,
      class: `${statusClass.WARNING} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_SHIPMENT_DELIVERED: {
      text: statusTextMapper.ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_MESSAGE_CONTENT_ACCEPTED: {
      text: statusTextMapper.CONTENT_ACCEPTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_MESSAGE_CONTENT_REJECTED: {
      text: statusTextMapper.CONTENT_REJECTED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_GOODS_RELEASED: {
      text: statusTextMapper.GOODS_RELEASED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_GOODS_REQUIRED_FOR_EXAMINATION_REFERRED: {
      text: statusTextMapper.EXAMINATION_REFERRED,
      class: `${statusClass.ERROR} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_GOODS_MAY_MOVE_DETAIN_TO_DESTINATION: {
      text: statusTextMapper.DETAIN,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS: {
      text: statusTextMapper.ARRIVAL_OF_GOODS,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING: {
      text: statusTextMapper.CUSTOMS_PROCESSING,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_ERROR_MESSAGE: {
      text: statusTextMapper.ERROR_MESSAGE,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_RNS_AUTHORISED_TO_DELIVER_CSA_SHIPMENT: {
      text: statusTextMapper.AUTHORISED,
      class: `${statusClass.POSITIVE} ${statusClass.BLOCK_LABEL}`,
    },
    STATE_CARGO_RELEASE_CANCEL_ACCEPTED: {
      text: statusTextMapper.RELEASE_CANCEL_ACCEPTED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_CANCEL_FILED: {
      text: statusTextMapper.RELEASE_CANCEL_FILED,
      class: statusClass.POSITIVE,
    },
    STATE_CARGO_RELEASE_CANCEL_REJECTED: {
      text: statusTextMapper.RELEASE_CANCEL_REJECTED,
      class: statusClass.ERROR,
    },
  },
};

function dateFormatter(seconds) {
  let time = moment.unix(seconds).format("MMMM Do, YYYY");
  if (time === "Invalid date") return null;
  return time;
}

function midDateFormatter(seconds,timezone) {
  try {
    let time;
    if(timezone){
      time = moment.tz(new Date(seconds) , timezone).format("MMM Do, YYYY");
    } else {
      time = moment.unix(seconds / 1000).format("MMM Do, YYYY");

    }
    if (time === "Invalid date") return null;
    return time;
  } catch (e) {
    console.error("Error converting epoch", e);
    return "";
  }
}

export function getCurrentEpoch() {
  return new Date().getTime();
}

export function getEpochDiffInMinutes(epoch1, epoch2) {
  const diffInMilliseconds = Math.abs(epoch1 - epoch2);
  const diffInMinutes = diffInMilliseconds / (1000 * 60);
  return diffInMinutes;
}

// export function convertEpochToUTCDate(epoch) {
//   // const date = new Date(epoch);
//   // const utcDate = date.toLocaleDateString();
//   // return utcDate;

//   var dateobj = new Date(epoch);
// function pad(n) {return n < 10 ? "0"+n : n;}
// var result = pad(dateobj.getDate())+"/"+pad(dateobj.getMonth()+1)+"/"+dateobj.getFullYear();
// return result
// }
// export function convertEpochToUTCDate(epoch) {
//   var dateobj = new Date(epoch);
//   var result = dateobj.toISOString().substring(8, 10) + "/" + dateobj.toISOString().substring(5, 7) + "/" + dateobj.toISOString().substring(0, 4);
//   return result;
// }

export function convertEpochToUTCDate(epoch) {
  function convertDateFormat(dateString) {
    var dateParts = dateString.split("-");
    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];

    var convertedDate = day + "/" + month + "/" + year;
    return convertedDate;
  }
  var dateobj = new Date(epoch);
  var options = { timeZone: 'America/Toronto', day: '2-digit', month: '2-digit', year: 'numeric' };
  var result = dateobj.toLocaleDateString('en-CA', options).replace(/\//g, '/');
  return convertDateFormat(result);
}

// console.log(convertEpochToDate3(1682532960000));


export function convertDateFormat(dateString) {
  const months = [
    { key: "01", val: 'Jan' },
    { key: "02", val: 'Feb' },
    { key: "03", val: 'Mar' },
    { key: "04", val: 'Apr' },
    { key: "05", val: 'May' },
    { key: "06", val: 'Jun' },
    { key: "07", val: 'Jul' },
    { key: "08", val: 'Aug' },
    { key: "09", val: 'Sep' },
    { key: "10", val: 'Oct' },
    { key: "11", val: 'Nov' },
    { key: "12", val: 'Dec' },
  ];
  const day = dateString.split('/')[0];
  const month = dateString.split('/')[1];
  const year = dateString.split('/')[2];
  const monthStr = months.find((i) => Number(i.key) == Number(month))?.val;
  let suffix = 'th';
  if (day == "01" || day == 21 || day == 31) {
    suffix = 'st';
  } else if (day == "02" || day == 22) {
    suffix = 'nd';
  } else if (day == "03" || day === 23) {
    suffix = 'rd';
  }

  if (Number(day) < 10) {
    return `${monthStr} ${day.toString().slice(1)}${suffix}, ${year}`;
  } else {
    return `${monthStr} ${day}${suffix}, ${year}`;
  }
}

function shortDateFormatter(seconds) {
  let time = moment.unix(seconds).format("MM/DD/YYYY");
  if (time === "Invalid date") return null;
  return time;
}

function longDateFormatter(seconds) {
  let time = moment.unix(seconds).format("dddd, MMMM Do YYYY, h:mm:ss a");
  if (time === "Invalid date") return null;
  return time;
}

const convertNumberStringToDate = (number) => {
  let str = String(number);
  let conStr = str.length < 6 ? "0" + str : str;

  let numToDate = moment(conStr, "MMDDYY");
  let convertedDate = moment(numToDate).format("MMM Do, YYYY");
  return convertedDate;
};

const convertEpochToDate = (epoch, shortFormat = false, longDate = false) => {
  if (!epoch || epoch === "TBD") return null;
  var date = new Date(Math.round(Number(epoch)));
  if (shortFormat) return shortDateFormatter(epoch / 1000);
  if (longDate) return longDateFormatter(epoch / 1000);
  return dateFormatter(epoch / 1000);
};

const convertEpochToDateAdvanced = (
  epoch,
  shortFormat = false,
  longDate = false
) => {
  if (!epoch || epoch === "TBD") return null;
  var date = new Date(Math.round(Number(epoch)));

  var today = moment();
  var yesterday = moment().subtract(1, "day");
  var tomorrow = moment().add(1, "day");

  var engagementDate = date;
  if (moment(engagementDate).isSame(today, "day")) return "Today";
  else if (moment(engagementDate).isSame(yesterday, "day")) return "Yesterday";
  else if (moment(engagementDate).isSame(tomorrow, "day")) return "Tomorrow";

  if (shortFormat) return shortDateFormatter(epoch / 1000);
  if (longDate) return longDateFormatter(epoch / 1000);
  return dateFormatter(epoch / 1000);
};

const mapActivityName = (description, status) => {
  if (status === "GRAY_MILESTONE") {
    if (mapperFuture[description]) return mapperFuture[description];
  } else {
    if (mapper[description]) return mapper[description];
  }
  return description;
};

const modals = {
  myFreightForwarders: "myFreightForwarders",
  myCustomers: "myCustomers",
  myBrokers: "myBrokers",
  myPersonalProfile: "myPersonalProfile",
  myCompany: "myCompany",
  businessSize: "businessSize",
  paymentInformation: "paymentInformation",
  paymentHistory: "paymentHistory",
  customsStatements: "customsStatements",
  shippingInformation: "shippingInformation",
  shippingDestinations: "shippingDestinations",
  manufacturers: "manufacturers",
  bondInformation: "bondInformation",
  communications: "communications",
  manageUsers: "manageUsers",
  myInvoices: "myInvoices",
};

const actorTabs = {
  myActors: "myActors",
  pendingApproval: "pendingApproval",
  addActor: "addActor",
  responseReceived: "responseReceived",
  invited: "invited",
};

const countryList = [
  { value: "US", text: "United States", key: "1", flag: "us" },
  { value: "CA", text: "Canada", key: "2", flag: "ca" },
  { value: "GB", text: "United kingdom", key: "3", flag: "gb" },
  { value: "ES", text: "Spain", key: "4", flag: "es" },
  { value: "NL", text: "Netherland", key: "5", flag: "nl" },
];

const monthList = [
  { Jan: "01" },
  { Feb: "02" },
  { Mar: "03" },
  { Apr: "04" },
  { May: "05" },
  { Jun: "06" },
  { Jul: "07" },
  { Aug: "08" },
  { Sep: "09" },
  { Oct: "10" },
  { Nov: "11" },
  { Dec: "12" },
];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const yearList = (new Array(new Date().getFullYear() + 2 - 2021)).fill().map((a, iii) => { return (2021 + iii) + "" });

// export const RO_BrokerStateOptions = [
//   { text : "CR ACCEPTED", value: "STATE_CARGO_RELEASE_ACCEPTED" },
//   { text : "CR ACCEPTED WITH WARNINGS", value: "STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS" },
//   { text : "CR CANCEL ACCEPTED", value: "STATE_CARGO_RELEASE_CANCEL_ACCEPTED" },
//   { text : "CR FILED", value: "STATE_CARGO_RELEASE_FILED" },
//   { text : "CR IN PROCESS", value: "STATE_CARGO_RELEASE_IN_PROCESS" },
//   { text : "CR REJECTED", value: "STATE_CARGO_RELEASE_REJECTED" },
//   { text : "ENTRY ACCOUNTING ACCEPTED", value: "STATE_ENTRY_ACCOUNTING_ACCEPTED" },
//   { text : "ENTRY ACCOUNTING FILED", value: "STATE_ENTRY_ACCOUNTING_FILED" },
//   { text : "ENTRY ACCOUNTING IN PROCESS", value: "STATE_ENTRY_ACCOUNTING_IN_PROCESS" },
//   { text : "ENTRY ACCOUNTING REJECTED", value: "STATE_ENTRY_ACCOUNTING_REJECTED" },
//   { text : "ES ACCEPTED", value: "STATE_ENTRY_SUMMARY_ACCEPTED" },
//   { text : "ES FILED", value: "STATE_ENTRY_SUMMARY_FILED" },
//   { text : "ES IN PROCESS", value: "STATE_ENTRY_SUMMARY_IN_PROCESS"},
//   { text : "ES REJECTED", value: "STATE_ENTRY_SUMMARY_REJECTED" },
//   { text : "C88 ENTRY ACCEPTED", value: "STATE_ENTRY_ACCEPTED" },
//   { text : "C88 ENTRY FILED", value: "STATE_ENTRY_FILED" },
//   { text : "C88 ENTRY IN PROCESS", value: "STATE_ENTRY_IN_PROCESS"},
//   { text : "C88 ENTRY AMEND IN PROCESS", value: "STATE_ENTRY_AMEND_IN_PROCESS"},
//   { text : "C88 ENTRY REJECTED", value: "STATE_ENTRY_REJECTED" }
// ];

export const US_BrokerStateOptions = [
  { text: "ES PENDING FILING", value: "STATE_ENTRY_SUMMARY_NONE" },
  { text: "CR PENDING FILING", value: "STATE_CARGO_RELEASE_NONE" },
  { text: "CR ACCEPTED", value: "STATE_CARGO_RELEASE_ACCEPTED" },
  {
    text: "CR ACCEPTED WITH WARNINGS",
    value: "STATE_CARGO_RELEASE_ACCEPTED_WITH_WARNINGS",
  },
  { text: "CR CANCEL ACCEPTED", value: "STATE_CARGO_RELEASE_RETRACT_ACCEPTED" },
  { text: "CR CANCEL REJECTED", value: "STATE_CARGO_RELEASE_RETRACT_REJECTED" },
  { text: "CR FILED", value: "STATE_CARGO_RELEASE_FILED" },
  { text: "CR IN PROCESS", value: "STATE_CARGO_RELEASE_IN_PROCESS" },
  { text: "CR REJECTED", value: "STATE_CARGO_RELEASE_REJECTED" },
  { text: "ES ACCEPTED", value: "STATE_ENTRY_SUMMARY_ACCEPTED" },
  { text: "ES FILED", value: "STATE_ENTRY_SUMMARY_FILED" },
  { text: "ES IN PROCESS", value: "STATE_ENTRY_SUMMARY_IN_PROCESS" },
  { text: "ES REJECTED", value: "STATE_ENTRY_SUMMARY_REJECTED" },
  { text: "ES CANCEL ACCEPTED", value: "STATE_ENTRY_SUMMARY_RETRACT_ACCEPTED" },
  { text: "ES CANCEL REJECTED", value: "STATE_ENTRY_SUMMARY_RETRACT_REJECTED" },
  {
    text: "ES ACCEPTED WITH WARNINGS",
    value: "STATE_ENTRY_SUMMARY_ACCEPTED_WITH_WARNINGS",
  },
  { text: "PSC IN PROCESS", value: "STATE_PSC_IN_PROCESS" },
  { text: "PSC READY", value: "STATE_PSC_READY" },
  { text: "PSC FILED", value: "STATE_PSC_FILED" },
  { text: "PSC ACCEPTED", value: "STATE_PSC_ACCEPTED" },
  { text: "PSC REJECTED", value: "STATE_PSC_REJECTED" },
  { text: "PSC ACC/WARNING", value: "STATE_PSC_ACCEPTED_WITH_WARNING" },
];

export const CA_BrokerStateOptions = [
  { text: "EA(B3) PENDING FILING", value: "STATE_ENTRY_ACCOUNTING_NONE" },
  { text: "CR(IID) PENDING FILING", value: "STATE_CARGO_RELEASE_NONE" },
  { text: "CR(IID) ACCEPTED", value: "STATE_CARGO_RELEASE_ACCEPTED" },
  { text: "CR(IID) FILED", value: "STATE_CARGO_RELEASE_FILED" },
  { text: "CR(IID) IN PROCESS", value: "STATE_CARGO_RELEASE_IN_PROCESS" },
  { text: "CR(IID) READY", value: "STATE_CARGO_RELEASE_READY" },
  { text: "CR(IID) REJECTED", value: "STATE_CARGO_RELEASE_REJECTED" },
  {
    text: "CR(IID) RNS MESSAGE CONTENT ACCEPTED",
    value: "STATE_RNS_MESSAGE_CONTENT_ACCEPTED",
  },
  {
    text: "CR(IID) RNS MESSAGE CONTENT REJECTED",
    value: "STATE_RNS_MESSAGE_CONTENT_REJECTED",
  },
  { text: "CR(IID) RNS GOODS RELEASED", value: "STATE_RNS_GOODS_RELEASED" },
  {
    text: "CR(IID) RNS GOODS REQUIRED FOR EXAMINATION REFERRED",
    value: "STATE_RNS_GOODS_REQUIRED_FOR_EXAMINATION_REFERRED",
  },
  {
    text: "CR(IID) RNS GOODS MAY MOVE DETAIN TO DESTINATION",
    value: "STATE_RNS_GOODS_MAY_MOVE_DETAIN_TO_DESTINATION",
  },
  {
    text: "CR(IID) RNS DECLARATION ACCEPTED AWAITING ARRIVAL OF GOODS",
    value: "STATE_RNS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS",
  },
  {
    text: "CR(IID) RNS GOODS MAY MOVE DETAIN TO DESTINATION",
    value: "STATE_RNS_GOODS_MAY_MOVE_DETAIN_TO_DESTINATION",
  },
  {
    text: "CR(IID) RNS DECLARATION ACCEPTED AWAITING ARRIVAL OF GOODS",
    value: "STATE_RNS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS",
  },
  {
    text: "CR(IID) RNS DECLARATION ACCEPTED AWAITING CUSTOMS PROCESSIN",
    value: "STATE_RNS_DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING",
  },
  { text: "CR(IID) RNS ERROR MESSAGE", value: "STATE_RNS_ERROR_MESSAGE" },
  {
    text: "CR(IID) RNS AUTHORISED TO DELIVER CSA SHIPMENT",
    value: "STATE_RNS_AUTHORISED_TO_DELIVER_CSA_SHIPMENT",
  },
  { text: "EA(B3) ACCEPTED", value: "STATE_ENTRY_ACCOUNTING_ACCEPTED" },
  { text: "EA(B3) FILED", value: "STATE_ENTRY_ACCOUNTING_FILED" },
  { text: "EA(B3) IN PROCESS", value: "STATE_ENTRY_ACCOUNTING_IN_PROCESS" },
  { text: "EA(B3) READY", value: "STATE_ENTRY_ACCOUNTING_READY" },
  { text: "EA(B3) REJECTED", value: "STATE_ENTRY_ACCOUNTING_REJECTED" },
];

export const GB_BrokerStateOptions = [
  { text: "C88/CDS ENTRY PENDING FILING", value: "STATE_ENTRY_NONE" },
  { text: "C88/CDS ENTRY ACCEPTED", value: "STATE_ENTRY_ACCEPTED" },
  { text: "ENTRY CLEARED", value: "STATE_ENTRY_CLEARED" },
  { text: "C88/CDS ENTRY FILED", value: "STATE_ENTRY_FILED" },
  { text: "C88/CDS ENTRY IN PROCESS", value: "STATE_ENTRY_IN_PROCESS" },
  { text: "C88/CDS ENTRY READY", value: "STATE_ENTRY_READY" },
  { text: "C88/CDS ENTRY AMEND IN PROCESS", value: "STATE_ENTRY_AMEND_IN_PROCESS" },
  { text: "C88/CDS ENTRY AMEND READY", value: "STATE_ENTRY_AMEND_READY" },
  { text: "C88/CDS ENTRY AMEND ACCEPTED", value: "STATE_ENTRY_AMEND_ACCEPTED" },
  { text: "C88/CDS ENTRY AMEND FAILED", value: "STATE_ENTRY_AMEND_FAILED" },
  { text: "C88/CDS ENTRY REJECTED", value: "STATE_ENTRY_REJECTED" },
  { text: "CDS ENTRY CANCEL ACCEPTED", value: "STATE_ENTRY_CANCELLED" },
  { text: "C88 ENTRY CANCEL ACCEPTED", value: "STATE_CANCEL_ACCEPTED" },
  { text: "C88 ENTRY CANCEL ACKNOWLEDGED", value: "STATE_CANCEL_ACKNOWLEDGED" },
  { text: "C88 ENTRY CANCEL REJECTED", value: "STATE_CANCEL_REJECTED" },
  { text: "C88 ENTRY ROUTE H", value: "STATE_ACCEPTED_ENTRY_ROUTE_H" },
  { text: "C88 ENTRY ROUTE 0", value: "STATE_ACCEPTED_ENTRY_ROUTE_0" },
  { text: "C88 ENTRY ROUTE 1_C", value: "STATE_ACCEPTED_ENTRY_ROUTE_1_C" },
  { text: "C88 ENTRY ROUTE 1", value: "STATE_ACCEPTED_ENTRY_ROUTE_1" },
  { text: "C88 ENTRY ROUTE 2", value: "STATE_ACCEPTED_ENTRY_ROUTE_2" },
  { text: "C88 ENTRY ROUTE 2_C", value: "STATE_ACCEPTED_ENTRY_ROUTE_2_C" },
  { text: "C88 ENTRY ROUTE 3", value: "STATE_ACCEPTED_ENTRY_ROUTE_3" },
  { text: "C88 ENTRY ROUTE 3_C", value: "STATE_ACCEPTED_ENTRY_ROUTE_3_C" },
  { text: "C88 ENTRY ROUTE 4", value: "STATE_ACCEPTED_ENTRY_ROUTE_4" },
  { text: "C88 ENTRY ROUTE 5", value: "STATE_ACCEPTED_ENTRY_ROUTE_5" },
  { text: "C88 ENTRY ROUTE 6", value: "STATE_ACCEPTED_ENTRY_ROUTE_6" },
  { text: "C88 ENTRY ROUTE 6_C", value: "STATE_ACCEPTED_ENTRY_ROUTE_6_C" },
  { text: "GOODS EXITED", value: "STATE_ENTRY_GOODS_EXITED" },
  { text: "CDS CUSTOM NONE", value: "STATE_CUSTOM_NONE" },
  { text: "CDS DMSACC - DECLARATION REGISTERED/ACCEPTED", value: "STATE_DMSACC" },
  { text: "CDS DMSREJ - DEC REJECTED", value: "STATE_DMSREJ" },
  { text: "CDS DMSALV - DMSALV", value: "STATE_DMSALV" },
  { text: "CDS DMSCTL - PHYSICALLY EXAMINE", value: "STATE_DMSCTL" },
  { text: "CDS DMSDOC - DOC REQUIRED", value: "STATE_DMSDOC" },
  { text: "CDS DMSQRY - HMRC QUERY", value: "STATE_DMSQRY" },
  { text: "CDS DMSRES - CORRECTION APPLIED", value: "STATE_DMSRES" },
  { text: "CDS DMSRCV - DECLARATION RECEIVED", value: "STATE_DMSRCV" },
  { text: "CDS DMSROG - GOODS RELEASED", value: "STATE_DMSROG" },
  { text: "CDS DMSCLE - CLEARED", value: "STATE_DMSCLE" },
  { text: "CDS DMSINV - DEC INVALIDATED", value: "STATE_DMSINV" },
  { text: "CDS DMSREQ - ADDITIONAL MESSAGE", value: "STATE_DMSREQ" },
  { text: "CDS DMSTAX - TAX VERIFICATION", value: "STATE_DMSTAX" },
  { text: "CDS DMSCPI - INSUFFICIENT BALANCE", value: "STATE_DMSCPI" },
  { text: "CDS DMSCPR - PAYMENT REQUIRED", value: "STATE_DMSCPR" },
  { text: "CDS DMSEOG - GOODS EXITED", value: "STATE_DMSEOG" }
];
export const NL_BrokerStateOptions = (t = (value) => value) => [
  { text: `${t("PENDING_FILING")}`, value: "STATE_ENTRY_NONE" },
  { text: `${t("ENTRY_IN_PROCESS")}`, value: "STATE_ENTRY_IN_PROCESS" },
  { text: `${t("ENTRY_STUCK")}`, value: "STATE_ENTRY_STUCK" },
  { text: `${t("ENTRY_ON_HOLD")}`, value: "STATE_ENTRY_ON_HOLD" },
  { text: `${t("ENTRY_READY")}`, value: "STATE_ENTRY_READY" },
  { text: `${t("ENTRY_FILED")}`, value: "STATE_ENTRY_FILED" },
  { text: `${t("ENTRY_CANCELLED_FILED")}`, value: "STATE_ENTRY_CANCELLED_FILED" },
  { text: `${t("ENTRY_CANCELLED_FAILED")}`, value: "STATE_CANCEL_FAILED" },
  { text: `${t("ENTRY_CANCELLED")}`, value: "STATE_ENTRY_CANCELLED" },
  { text: `${t("ENTRY_ACCEPTED")}`, value: "STATE_ENTRY_ACCEPTED" },
  { text: `${t("ENTRY_REJECTED")}`, value: "STATE_ENTRY_REJECTED" },
  { text: `${t("ENTRY_AMEND_IN_PROCESS")}`, value: "STATE_ENTRY_AMEND_IN_PROCESS" },
  { text: `${t("ENTRY_AMEND_FILED")}`, value: "STATE_ENTRY_AMEND_FILED" },
  { text: `${t("ENTRY_AMEND_ACCEPTED")}`, value: "STATE_ENTRY_AMEND_ACCEPTED" },
  { text: `${t("ENTRY_AMEND_REJECTED")}`, value: "STATE_ENTRY_AMEND_REJECTED" },
  { text: `${t("ENTRY_RELEASED")}`, value: "STATE_ENTRY_RELEASED" },
  { text: `${t("ENTRY_COMPLETED")}`, value: "STATE_ENTRY_COMPLETED" },
  { text: `${t("ENTRY_FROZEN")}`, value: "STATE_ENTRY_FROZEN" },
  { text: `${t("ENTRY_SUP_IN_PROCESS")}`, value: "STATE_ENTRY_SUP_IN_PROCESS" },
  { text: `${t("ENTRY_SUP_READY")}`, value: "STATE_ENTRY_SUP_READY" },
  { text: `${t("ENTRY_SUP_FILED")}`, value: "STATE_ENTRY_SUP_FILED" },
  { text: `${t("ENTRY_SUP_ACCEPTED")}`, value: "STATE_ENTRY_SUP_ACCEPTED" },
  { text: `${t("ENTRY_REJECTED")}`, value: "STATE_ENTRY_SUP_REJECTED" },
  { text: `${t("ENTRY_EXT_IN_PROCESS")}`, value: "STATE_ENTRY_EXT_IN_PROCESS" },
  { text: `${t("ENTRY_EXT_READY")}`, value: "STATE_ENTRY_EXT_READY" },
  { text: `${t("ENTRY_EXT_FILED")}`, value: "STATE_ENTRY_EXT_FILED" },
  { text: `${t("ENTRY_EXT_ACCEPTED")}`, value: "STATE_ENTRY_EXT_ACCEPTED" },
  { text: `${t("ENTRY_EXT_REJECTED")}`, value: "STATE_ENTRY_EXT_REJECTED" },


  { text: `DMSCRE - ${t("DECLARATION_CREATED")}`, value: "STATE_DMSCRE" },
  { text: `DMSACK - ${t("DECLARATION_ACKNOWLEDGED")}`, value: "STATE_DMSACK" },
  { text: `DMSRCV - ${t("DECLARATION_RECEIVED")}`, value: "STATE_DMSRCV" },
  { text: `DMSSENT - ${t("DECLARATION_SENT")}`, value: "STATE_DMSSENT" },
  { text: `CONTRL - ${t("DECLARATION_REJECTED")}`, value: "STATE_CONTRL" },
  { text: `DMSREJ - ${t("DECLARATION_REJECTED")}`, value: "STATE_DMSREJ" },
  { text: `DMSACC - ${t("DECLARATION_ACCEPTED")}`, value: "STATE_DMSACC" },
  { text: `DMSDOC - ${t("DOCUMENTS_CONTROL")}`, value: "STATE_DMSDOC" },
  { text: `DMSCTL - ${t("PHYSICAL_INSPECTION")}`, value: "STATE_DMSCTL" },
  { text: `DMSROG - ${t("PROVISIONALLY_RELEASED")}`, value: "STATE_DMSROG" },
  { text: `DMSRES - ${t("ENTRY_ADJUSTED")}`, value: "STATE_DMSRES" },
  { text: `DMSCLE - ${t("FINAL_RELEASE")}`, value: "STATE_DMSCLE" },
  { text: `ALTREM - ${t("SEND_EXIT_INFO")}`, value: "STATE_ALTREM" },
  { text: `ALTSENT - ${t("EXIT_INFO_SENT")}`, value: "STATE_ALTSENT" },
  { text: `ALTREJ - ${t("EXIT_INFO_REJECTED")}`, value: "STATE_ALTREJ" },
  { text: `ALTRCV - ${t("EXIT_INFO_RECIEVED")}`, value: "STATE_ALTRCV" },

  { text: `DMSEOG - ${t("EXIT_CONFIRMATION")}`, value: "STATE_DMSEOG" },
  { text: `DMSINV - ${t("DECLARATION_CANCELLED")}`, value: "STATE_DMSINV" },

  { text: `DMSEXT - ${t("EXTERNAL_HANDLING")}`, value: "STATE_DMSEXT" },

  { text: `CORSENT - ${t("AMENDMENT_REQUEST_SENT")}`, value: "STATE_CORSENT" },
  { text: `CORACK - ${t("AMENDMENT_ACKNOLEDGED")}`, value: "STATE_CORACK" },
  { text: `CORREJ - ${t("AMENDMENT_REJECTED")}`, value: "STATE_CORREJ" },
  { text: `CORRCV - ${t("AMENDMENT_RECEIVED")}`, value: "STATE_CORRCV" },
  { text: `CORREQ - ${t("AMENDMENT_DECISION")}`, value: "STATE_CORREQ" },
  { text: `CORRES - ${t("AMENDMENT_FINALIZED")}`, value: "STATE_CORACC" },

  { text: `INVSENT - ${t("CANCEL_REQUEST_SENT")}`, value: "STATE_INVSENT" },
  { text: `INVACK - ${t("CANCEL_ACKNOLEDGED")}`, value: "STATE_INVACK" },
  { text: `INVREJ - ${t("CANCELLATION_REJECTED")}`, value: "STATE_INVREJ" },
  { text: `INVRCV - ${t("CANCELLATION_RECEIVED")}`, value: "STATE_INVRCV" },
  { text: `INVREQ - ${t("CANCELLATION_DECISION")}`, value: "STATE_INVREQ" },

  { text: `SUPSENT - ${t("SUPPLEMENT_SENT")}`, value: "STATE_SUPSENT" },
  { text: `SUPRCV - ${t("SUPPLEMENT_RECIEVED")}`, value: "STATE_SUPRCV" },
  { text: `SUPREQ - ${t("SUPPLEMENT_DECISION")}`, value: "STATE_SUPREQ" },
  { text: `SUPREJ - ${t("SUPPLEMENT_REJECTED")}`, value: "STATE_SUPREJ" },
  { text: `SUPRES - ${t("SUPPLEMENT_FINALIZED")}`, value: "STATE_SUPRES" },

];

export const ES_BrokerStateOptions = (t = (value) => value) => [
  { text: t("ENTRY_NONE"), value: "STATE_ENTRY_NONE" },
  { text: t("ENTRY_IN_PROCESS"), value: "STATE_ENTRY_IN_PROCESS" },
  { text: t("ENTRY_STUCK"), value: "STATE_ENTRY_STUCK" },
  { text: t("ENTRY_ON_HOLD"), value: "STATE_ENTRY_ON_HOLD" },
  { text: t("ENTRY_READY"), value: "STATE_ENTRY_READY" },
  { text: t("ENTRY_FILED"), value: "STATE_ENTRY_FILED" },
  { text: `${t("ENTRY_CANCELLED_FILED")}`, value: "STATE_ENTRY_CANCELLED_FILED" },
  { text: `${t("ENTRY_CANCELLED_FAILED")}`, value: "STATE_CANCEL_FAILED" },
  { text: `${t("ENTRY_CANCELLED")}`, value: "STATE_ENTRY_CANCELLED" },
  { text: t("CUSTOMS_CANCELLED_FILED"), value: "STATE_CANCEL_FILED" },
  { text: t("CUSTOMS_CANCELLED_FAILED"), value: "STATE_CANCEL_FAILED" },
  { text: t("CUSTOMS_CANCELLED_ACCEPTED"), value: "STATE_CANCELLED" },
  { text: t("ENTRY_ACCEPTED"), value: "STATE_ENTRY_ACCEPTED" },
  { text: t("ENTRY_REJECTED"), value: "STATE_ENTRY_REJECTED" },
  { text: t("ENTRY_AMEND_IN_PROCESS"), value: "STATE_ENTRY_AMEND_IN_PROCESS" },
  { text: t("ENTRY_AMEND_FILED"), value: "STATE_ENTRY_AMEND_FILED" },
  { text: t("ENTRY_AMEND_ACCEPTED"), value: "STATE_ENTRY_AMEND_ACCEPTED" },
  { text: t("ENTRY_AMEND_REJECTED"), value: "STATE_ENTRY_AMEND_REJECTED" },
  { text: t("PENDING_FILING"), value: "STATE_CUSTOMS_NONE" },
  { text: t("PDI_NEW"), value: "STATE_PDI_NEW" },
  { text: t("PDI_FILED"), value: "STATE_PDI_FILED" },
  { text: t("PDI_FILED_FAILED"), value: "STATE_PDI_FILED_FAILED" },
  { text: t("PDI_CANCELLED_FILED"), value: "STATE_PDI_CANCELLED_FILED" },
  { text: t("PDI_CANCELLED_FILED_FAILED"), value: "STATE_PDI_CANCELLED_FILED_FAILED" },
  { text: t("PDI_ACCEPTED"), value: "STATE_PDI_ACCEPTED" },
  { text: t("PDI_AMEND_FILED"), value: "STATE_PDI_AMEND_FILED" },
  { text: t("PDC_NEW"), value: "STATE_PDC_NEW" },
  { text: t("PDC_FILED"), value: "STATE_PDC_FILED" },
  { text: t("PDC_FILED_FAILED"), value: "STATE_PDC_FILED_FAILED" },
  { text: t("PDC_CANCELLED_FILED"), value: "STATE_PDC_CANCELLED_FILED" },
  { text: t("PDC_CANCELLED_FILED_FAILED"), value: "STATE_PDC_CANCELLED_FILED_FAILED" },
  { text: t("PDC_ACCEPTED"), value: "STATE_PDC_ACCEPTED" },
  { text: t("PDC_AMEND_FILED"), value: "STATE_PDC_AMEND_FILED" },
  { text: t("PDC_AMEND_IN_PROCESS"), value: "STATE_PDC_AMEND_NEW" },
  { text: t("PDC_AMEND_FAILED"), value: "STATE_PDC_AMEND_FAILED" },
  { text: t("FULL_SAD_FILED"), value: "STATE_FULL_SAD_FILED" },
  { text: t("FULL_SAD_FAILED"), value: "STATE_FULL_SAD_FAILED" },
  { text: t("FULL_SAD_CANCELLED_FILED"), value: "STATE_FULL_SAD_CANCELLED_FILED" },
  { text: t("FULL_SAD_CANCELLED_FILED_FAILED"), value: "STATE_FULL_SAD_CANCELLED_FILED_FAILED" },
  { text: t("FULL_SAD_ACCEPTED"), value: "STATE_FULL_SAD_ACCEPTED" },
  { text: t("BOX_40_REQUIRED"), value: "STATE_BOX_40_REQUIRED" },
  { text: t("BOX_40_FILED"), value: "STATE_BOX_40_FILED" },
  { text: t("BOX_40_FAILED"), value: "STATE_BOX_40_FAILED" },
  { text: t("BOX_40_ACCEPTED"), value: "STATE_BOX_40_ACCEPTED" },
  { text: t("BOX_44_REQUIRED"), value: "STATE_BOX_44_REQUIRED" },
  { text: t("BOX_44_FILED"), value: "STATE_BOX_44_FILED" },
  { text: t("BOX_44_FAILED"), value: "STATE_BOX_44_FAILED" },
  { text: t("BOX_44_ACCEPTED"), value: "STATE_BOX_44_ACCEPTED" },

  { text: t("TYPE_A_NEW"), value: "STATE_TYPE_A_NEW" },
  { text: t("TYPE_A_FILED"), value: "STATE_TYPE_A_FILED" },
  { text: t("TYPE_A_FILED_FAILED"), value: "STATE_TYPE_A_FILED_FAILED" },
  { text: t("TYPE_A_ACCEPTED"), value: "STATE_TYPE_A_ACCEPTED" },
  { text: t("TYPE_A_AMEND_NEW"), value: "STATE_TYPE_A_AMEND_NEW" },
  { text: t("TYPE_A_AMEND_FILED"), value: "STATE_TYPE_A_AMEND_FILED" },
  { text: t("TYPE_A_AMEND_FAILED"), value: "STATE_TYPE_A_AMEND_FAILED" },
  { text: t("TYPE_A_AMEND_ACCEPTED"), value: "STATE_TYPE_A_AMEND_ACCEPTED" },
  { text: t("TYPE_B_NEW"), value: "STATE_TYPE_B_NEW" },
  { text: t("TYPE_B_FILED"), value: "STATE_TYPE_B_FILED" },
  { text: t("TYPE_B_FILED_FAILED"), value: "STATE_TYPE_B_FILED_FAILED" },
  { text: t("TYPE_B_ACCEPTED"), value: "STATE_TYPE_B_ACCEPTED" },
  { text: t("TYPE_B_AMEND_NEW"), value: "STATE_TYPE_B_AMEND_NEW" },
  { text: t("TYPE_B_AMEND_FILED"), value: "STATE_TYPE_B_AMEND_FILED" },
  { text: t("TYPE_B_AMEND_FAILED"), value: "STATE_TYPE_B_AMEND_FAILED" },
  { text: t("TYPE_B_AMEND_ACCEPTED"), value: "STATE_TYPE_B_AMEND_ACCEPTED" },
  { text: t("TYPE_C_NEW"), value: "STATE_TYPE_C_NEW" },
  { text: t("TYPE_C_FILED"), value: "STATE_TYPE_C_FILED" },
  { text: t("TYPE_C_FILED_FAILED"), value: "STATE_TYPE_C_FILED_FAILED" },
  { text: t("TYPE_C_ACCEPTED"), value: "STATE_TYPE_C_ACCEPTED" },
  { text: t("TYPE_C_AMEND_NEW"), value: "STATE_TYPE_C_AMEND_NEW" },
  { text: t("TYPE_C_AMEND_FILED"), value: "STATE_TYPE_C_AMEND_FILED" },
  { text: t("TYPE_C_AMEND_FAILED"), value: "STATE_TYPE_C_AMEND_FAILED" },
  { text: t("TYPE_C_AMEND_ACCEPTED"), value: "STATE_TYPE_C_AMEND_ACCEPTED" },
  { text: t("TYPE_D_NEW"), value: "STATE_TYPE_D_NEW" },
  { text: t("TYPE_D_FILED"), value: "STATE_TYPE_D_FILED" },
  { text: t("TYPE_D_FILED_FAILED"), value: "STATE_TYPE_D_FILED_FAILED" },
  { text: t("TYPE_D_ACCEPTED"), value: "STATE_TYPE_D_ACCEPTED" },
  { text: t("TYPE_D_AMEND_NEW"), value: "STATE_TYPE_D_AMEND_NEW" },
  { text: t("TYPE_D_AMEND_FILED"), value: "STATE_TYPE_D_AMEND_FILED" },
  { text: t("TYPE_D_AMEND_FAILED"), value: "STATE_TYPE_D_AMEND_FAILED" },
  { text: t("TYPE_D_AMEND_ACCEPTED"), value: "STATE_TYPE_D_AMEND_ACCEPTED" },
  { text: t("TYPE_PRE_NEW"), value: "STATE_TYPE_PRE_NEW" },
  { text: t("TYPE_PRE_FILED"), value: "STATE_TYPE_PRE_FILED" },
  { text: t("TYPE_PRE_FILED_FAILED"), value: "STATE_TYPE_PRE_FILED_FAILED" },
  { text: t("TYPE_PRE_ACCEPTED"), value: "STATE_TYPE_PRE_ACCEPTED" },
  { text: t("TYPE_CER_NEW"), value: "STATE_TYPE_CER_NEW" },
  { text: t("TYPE_CER_FILED"), value: "STATE_TYPE_CER_FILED" },
  { text: t("TYPE_CER_FILED_FAILED"), value: "STATE_TYPE_CER_FAILED" },
  { text: t("TYPE_CER_ACCEPTED"), value: "STATE_TYPE_CER_ACCEPTED" },
  { text: t("TYPE_X_NEW"), value: "STATE_TYPE_X_NEW" },
  { text: t("TYPE_X_FILED"), value: "STATE_TYPE_X_FILED" },
  { text: t("TYPE_X_FILED_FAILED"), value: "STATE_TYPE_X_FAILED" },
  { text: t("TYPE_X_ACCEPTED"), value: "STATE_TYPE_X_ACCEPTED" },
  { text: t("TYPE_Y_NEW"), value: "STATE_TYPE_Y_NEW" },
  { text: t("TYPE_Y_FILED"), value: "STATE_TYPE_Y_FILED" },
  { text: t("TYPE_Y_FILED_FAILED"), value: "STATE_TYPE_Y_FAILED" },
  { text: t("TYPE_Y_ACCEPTED"), value: "STATE_TYPE_Y_ACCEPTED" },
  { text: t("TYPE_NOT_NEW"), value: "STATE_TYPE_NOT_NEW" },
  { text: t("TYPE_NOT_FILED"), value: "STATE_TYPE_NOT_FILED" },
  { text: t("TYPE_NOT_FILED_FAILED"), value: "STATE_TYPE_NOT_FAILED" },
  { text: t("TYPE_NOT_ACCEPTED"), value: "STATE_TYPE_NOT_ACCEPTED" },

  { text: t("CLEAR"), value: "STATE_CLEAR" },
  { text: t("RELEASED").toUpperCase(), value: "STATE_RELEASED" }
]


export const NCTS_BrokerStateOptions = [
  { text: "TRANSIT NONE", value: "STATE_TRANSIT_NONE" },
  { text: "TRANSIT NEW", value: "STATE_TRANSIT_NEW" },
  { text: "TRANSIT PENDING", value: "STATE_TRANSIT_PENDING" },
  { text: "TRANSIT FILING IN PROCESS", value: "STATE_TRANSIT_FILING_IN_PROCESS" },
  { text: "TRANSIT FILE READY", value: "STATE_TRANSIT_READY_TO_FILE" },
  { text: "TRANSIT FILED", value: "STATE_TRANSIT_FILED" },
  { text: "TRANSIT FILE FAILED", value: "STATE_TRANSIT_FILED_FAILED" },
  { text: "TRANSIT FILED REJECTED", value: "STATE_TRANSIT_FILED_REJECTED" },
  { text: "TRANSIT DECLARATION FAILED", value: "STATE_TRANSIT_DECLARATION_FAILED" },
  { text: "TRANSIT FILED ACKNOWLEDGED", value: "STATE_TRANSIT_FILED_ACKNOWLEDGED" },
  { text: "TRANSIT CANCELLATION FILED", value: "STATE_TRANSIT_CANCELLATION_FILED" },
  { text: "TRANSIT CANCELLATION FILED FAILED", value: "STATE_TRANSIT_CANCELLATION_FILED_FAILED" },
  { text: "TRANSIT CANCELLATION ACCEPTED", value: "STATE_TRANSIT_CANCELLATION_ACCEPTED" },

  { text: "TRANSIT SKIPPED / ARRIVAL NEW", value: "STATE_TRANSIT_SKIPPED" },
  { text: "ARRIVAL IN PROCESS", value: "STATE_TRANSIT_ARRIVAL_IN_PROCESS" },
  { text: "ARRIVAL FILE READY", value: "STATE_TRANSIT_ARRIVAL_READY_TO_FILED" },
  { text: "ARRIVAL FILED ACKNOWLEDGED", value: "STATE_TRANSIT_ARRIVAL_FILED_ACKNOWLEDGED" },
  { text: "ARRIVAL FILE FAILED", value: "STATE_TRANSIT_ARRIVAL_FILED_FAILED" },
  { text: "ARRIVAL FILED REJECTED", value: "STATE_TRANSIT_ARRIVAL_FILED_REJECTED" },

  { text: "UNLOADING NEW", value: "STATE_TRANSIT_UNLOAD_NEW" },
  { text: "UNLOADING IN PROCESS", value: "STATE_TRANSIT_UNLOAD_IN_PROCESS" },
  { text: "UNLOADING FILE READY", value: "STATE_TRANSIT_UNLOAD_READY_TO_FILED" },
  { text: "UNLOADING FILED ACKNOWLEDGED", value: "STATE_TRANSIT_UNLOAD_FILED_ACKNOWLEDGED" },
  { text: "UNLOADING FILE FAILED", value: "STATE_TRANSIT_UNLOAD_FILED_FAILED" },
  { text: "UNLOADING FILED REJECTED", value: "STATE_TRANSIT_UNLOAD_FILED_REJECTED" },
  { text: "TRANSIT COMPLETE", value: "STATE_TRANSIT_COMPLETE" },

  { text: "NCTS NONE", value: "STATE_NCTS_NONE" },
  { text: "NCTS DECLARATION DATA MESSAGE", value: "STATE_DECLARATION_DATA_MESSAGE" },
  { text: "NCTS DECLARATION DATA REJECTED", value: "STATE_DECLARATION_DATA_REJECTED" },
  { text: "NCTS POSITIVE ACKNOWLEDGEMENT MESSAGE", value: "STATE_POSITIVE_ACKNOWLEDGEMENT_MESSAGE" },
  { text: "NCTS MRN ALLOCATED", value: "STATE_MRN_ALLOCATED" },
  { text: "NCTS GUARANTEE NOT VALID", value: "STATE_GUARANTEE_NOT_VALID" },
  { text: "NCTS CONTROL DECISION NOTIFICATION", value: "STATE_CONTROL_DECISION_NOTIFICATION" },
  { text: "NCTS RELEASE FOR TRANSIT", value: "STATE_RELEASE_FOR_TRANSIT" },
  { text: "NCTS NO RELEASE FOR TRANSIT", value: "STATE_NO_RELEASE_FOR_TRANSIT" },
  { text: "NCTS ARRIVAL NOTIFICATION MESSAGE", value: "STATE_TRANSIT_ARRIVAL_NOTIFICATION_MESSAGE" },
  { text: "NCTS ARRIVAL NOTIFICATION REJECTION", value: "STATE_TRANSIT_ARRIVAL_NOTIFICATION_REJECTION" },
  { text: "NCTS DECLARATION CANCELLATION REQUEST", value: "STATE_DECLARATION_CANCELLATION_REQUEST" },
  { text: "NCTS UNLOADING REMARKS", value: "STATE_UNLOADING_REMARKS" },
  { text: "NCTS GOODS RELEASE NOTIFICATION", value: "STATE_GOODS_RELEASE_NOTIFICATION" },
  { text: "NCTS UNLOADING REMARKS REJECTION", value: 'STATE_UNLOADING_REMARKS_REJECTION' },
  { text: "NCTS GOODS MOVEMENT COMPLETE", value: "STATE_GOODS_MOVEMENT_COMPLETE" },
];

export const RO_BrokerStateOptions = (t = (value) => value) => uniqBy(
  US_BrokerStateOptions.concat(CA_BrokerStateOptions, GB_BrokerStateOptions,
    NL_BrokerStateOptions(t), ES_BrokerStateOptions(t)),
  function (e) {
    return e.value;
  }
);

const getStateText = (country, jobState, t) => {
  let stateList = [];
  if (window.shipmentMode === 'TRANSIT_SHIPMENTS') {
    stateList = NCTS_BrokerStateOptions.slice();
  } else {
    switch (country) {
      case "US": {
        stateList = US_BrokerStateOptions.slice();
        break;
      }
      case "CA": {
        stateList = CA_BrokerStateOptions.slice();
        break;
      }
      case "GB": {
        stateList = GB_BrokerStateOptions.slice();
        break;
      }
      case "ES": {
        stateList = ES_BrokerStateOptions(t).slice();
        break;
      }
      case "NL": {
        stateList = NL_BrokerStateOptions(t).slice();
        break;
      }
      default: {
        stateList = RO_BrokerStateOptions(t).slice();
        break;
      }
    }
  }
  return stateList.filter((item) => {
    return item.value === jobState;
  })[0] || { text: jobState.replaceAll("_", " ") };
};

const guaranteeServiceType = [
  { key: "IMPORT", text: "IMPORT", value: "IMPORT" },
  { key: "TRANSIT", text: "TRANSIT", value: "TRANSIT" },
]

const spainGrnType = [
  { key: "GLOBAL", text: "GLOBAL", value: "GLOBAL" },
  { key: "INDIVIDUAL", text: "INDIVIDUAL", value: "INDIVIDUAL_1" },
  { key: "RESOURCES", text: "RESOURCES", value: "RESOURCES" },
]

const spainGrnOfc = [
  { key: "ES000141", text: "ES000141", value: "ES000141" },
  { key: "ES000241", text: "ES000241", value: "ES000241" },
  { key: "ES000311", text: "ES000311", value: "ES000311" },
  { key: "ES000411", text: "ES000411", value: "ES000411" },
  { key: "ES000415", text: "ES000415", value: "ES000415" },
  { key: "ES000641", text: "ES000641", value: "ES000641" },
  { key: "ES000671", text: "ES000671", value: "ES000671" },
  { key: "ES000701", text: "ES000701", value: "ES000701" },
  { key: "ES000711", text: "ES000711", value: "ES000711" },
  { key: "ES000721", text: "ES000721", value: "ES000721" },
  { key: "ES000731", text: "ES000731", value: "ES000731" },
  { key: "ES000811", text: "ES000811", value: "ES000811" },
  { key: "ES000812", text: "ES000812", value: "ES000812" },
  { key: "ES000941", text: "ES000941", value: "ES000941" },
  { key: "ES001041", text: "ES001041", value: "ES001041" },
  { key: "ES001101", text: "ES001101", value: "ES001101" },
  { key: "ES001111", text: "ES001111", value: "ES001111" },
  { key: "ES001131", text: "ES001131", value: "ES001131" },
  { key: "ES001167", text: "ES001167", value: "ES001167" },
  { key: "ES001211", text: "ES001211", value: "ES001211" },
  { key: "ES001341", text: "ES001341", value: "ES001341" },
  { key: "ES001441", text: "ES001441", value: "ES001441" },
  { key: "ES001507", text: "ES001507", value: "ES001507" },
  { key: "ES001511", text: "ES001511", value: "ES001511" },
  { key: "ES001521", text: "ES001521", value: "ES001521" },
  { key: "ES001641", text: "ES001641", value: "ES001641" },
  { key: "ES001711", text: "ES001711", value: "ES001711" },
  { key: "ES001741", text: "ES001741", value: "ES001741" },
  { key: "ES001771", text: "ES001771", value: "ES001771" },
  { key: "ES001811", text: "ES001811", value: "ES001811" },
  { key: "ES001841", text: "ES001841", value: "ES001841" },
  { key: "ES001941", text: "ES001941", value: "ES001941" },
  { key: "ES001950", text: "ES001950", value: "ES001950" },
  { key: "ES002011", text: "ES002011", value: "ES002011" },
  { key: "ES002045", text: "ES002045", value: "ES002045" },
  { key: "ES002051", text: "ES002051", value: "ES002051" },
  { key: "ES002111", text: "ES002111", value: "ES002111" },
  { key: "ES002341", text: "ES002341", value: "ES002341" },
  { key: "ES002441", text: "ES002441", value: "ES002441" },
  { key: "ES002541", text: "ES002541", value: "ES002541" },
  { key: "ES002641", text: "ES002641", value: "ES002641" },
  { key: "ES002711", text: "ES002711", value: "ES002711" },
  { key: "ES002800", text: "ES002800", value: "ES002800" },
  { key: "ES002801", text: "ES002801", value: "ES002801" },
  { key: "ES002901", text: "ES002901", value: "ES002901" },
  { key: "ES002911", text: "ES002911", value: "ES002911" },
  { key: "ES003001", text: "ES003001", value: "ES003001" },
  { key: "ES003011", text: "ES003011", value: "ES003011" },
  { key: "ES003051", text: "ES003051", value: "ES003051" },
  { key: "ES003161", text: "ES003161", value: "ES003161" },
  { key: "ES003311", text: "ES003311", value: "ES003311" },
  { key: "ES003331", text: "ES003331", value: "ES003331" },
  { key: "ES003541", text: "ES003541", value: "ES003541" },
  { key: "ES003561", text: "ES003561", value: "ES003561" },
  { key: "ES003591", text: "ES003591", value: "ES003591" },
  { key: "ES003611", text: "ES003611", value: "ES003611" },
  { key: "ES003621", text: "ES003621", value: "ES003621" },
  { key: "ES003631", text: "ES003631", value: "ES003631" },
  { key: "ES003741", text: "ES003741", value: "ES003741" },
  { key: "ES003861", text: "ES003861", value: "ES003861" },
  { key: "ES003871", text: "ES003871", value: "ES003871" },
  { key: "ES003891", text: "ES003891", value: "ES003891" },
  { key: "ES003911", text: "ES003911", value: "ES003911" },
  { key: "ES004111", text: "ES004111", value: "ES004111" },
  { key: "ES004311", text: "ES004311", value: "ES004311" },
  { key: "ES004341", text: "ES004341", value: "ES004341" },
  { key: "ES004350", text: "ES004350", value: "ES004350" },
  { key: "ES004541", text: "ES004541", value: "ES004541" },
  { key: "ES004611", text: "ES004611", value: "ES004611" },
  { key: "ES004621", text: "ES004621", value: "ES004621" },
  { key: "ES004631", text: "ES004631", value: "ES004631" },
  { key: "ES004741", text: "ES004741", value: "ES004741" },
  { key: "ES004825", text: "ES004825", value: "ES004825" },
  { key: "ES005001", text: "ES005001", value: "ES005001" },
]

const nlGrnOfc = [
  { key: "NL000144", text: "NL000144", value: "NL000144" },
  { key: "NL000155", text: "NL000155", value: "NL000155" },
  { key: "NL000158", text: "NL000158", value: "NL000158" },
  { key: "NL000184", text: "NL000184", value: "NL000184" },
  { key: "NL000187", text: "NL000187", value: "NL000187" },
  { key: "NL000204", text: "NL000204", value: "NL000204" },
  { key: "NL000205", text: "NL000205", value: "NL000205" },
  { key: "NL000282", text: "NL000282", value: "NL000282" },
  { key: "NL000396", text: "NL000396", value: "NL000396" },
  { key: "NL000432", text: "NL000432", value: "NL000432" },
  { key: "NL000476", text: "NL000476", value: "NL000476" },
  { key: "NL000510", text: "NL000510", value: "NL000510" },
  { key: "NL000511", text: "NL000511", value: "NL000511" },
  { key: "NL000563", text: "NL000563", value: "NL000563" },
  { key: "NL000850", text: "NL000850", value: "NL000850" },
  { key: "NL000851", text: "NL000851", value: "NL000851" },
  { key: "NL000853", text: "NL000853", value: "NL000853" },
  { key: "NL000854", text: "NL000854", value: "NL000854" },
  { key: "NL000855", text: "NL000855", value: "NL000855" },
  { key: "NL000856", text: "NL000856", value: "NL000856" },
]

const currency = [
  { key: "AED", text: "AED", value: "AED" },
  { key: "ANG", text: "ANG", value: "ANG" },
  { key: "AUD", text: "AUD", value: "AUD" },
  { key: "AWG", text: "AWG", value: "AWG" },
  { key: "BDT", text: "BDT", value: "BDT" },
  { key: "BGN", text: "BGN", value: "BGN" },
  { key: "BHD", text: "BHD", value: "BHD" },
  { key: "BND", text: "BND", value: "BND" },
  { key: "BRL", text: "BRL", value: "BRL" },
  { key: "BWP", text: "BWP", value: "BWP" },
  { key: "BYN", text: "BYN", value: "BYN" },
  { key: "CAD", text: "CAD", value: "CAD" },
  { key: "CHF", text: "CHF", value: "CHF" },
  { key: "CLP", text: "CLP", value: "CLP" },
  { key: "CNY", text: "CNY", value: "CNY" },
  { key: "CRC", text: "CRC", value: "CRC" },
  { key: "CZK", text: "CZK", value: "CZK" },
  { key: "DKK", text: "DKK", value: "DKK" },
  { key: "DOP", text: "DOP", value: "DOP" },
  { key: "DZD", text: "DZD", value: "DZD" },
  { key: "EGP", text: "EGP", value: "EGP" },
  { key: "EUR", text: "EUR", value: "EUR" },
  { key: "FJD", text: "FJD", value: "FJD" },
  { key: "GBP", text: "GBP", value: "GBP" },
  { key: "GHS", text: "GHS", value: "GHS" },
  { key: "GTQ", text: "GTQ", value: "GTQ" },
  { key: "HKD", text: "HKD", value: "HKD" },
  { key: "HRK", text: "HRK", value: "HRK" },
  { key: "HUF", text: "HUF", value: "HUF" },
  { key: "IDR", text: "IDR", value: "IDR" },
  { key: "ILS", text: "ILS", value: "ILS" },
  { key: "INR", text: "INR", value: "INR" },
  { key: "IQD", text: "IQD", value: "IQD" },
  { key: "ISK", text: "ISK", value: "ISK" },
  { key: "JMD", text: "JMD", value: "JMD" },
  { key: "JOD", text: "JOD", value: "JOD" },
  { key: "JPY", text: "JPY", value: "JPY" },
  { key: "KES", text: "KES", value: "KES" },
  { key: "KRW", text: "KRW", value: "KRW" },
  { key: "KWD", text: "KWD", value: "KWD" },
  { key: "LKR", text: "LKR", value: "LKR" },
  { key: "MAD", text: "MAD", value: "MAD" },
  { key: "MOP", text: "MOP", value: "MOP" },
  { key: "MUR", text: "MUR", value: "MUR" },
  { key: "MWK", text: "MWK", value: "MWK" },
  { key: "MXN", text: "MXN", value: "MXN" },
  { key: "MYR", text: "MYR", value: "MYR" },
  { key: "NGN", text: "NGN", value: "NGN" },
  { key: "NOK", text: "NOK", value: "NOK" },
  { key: "NZD", text: "NZD", value: "NZD" },
  { key: "OMR", text: "OMR", value: "OMR" },
  { key: "PHP", text: "PHP", value: "PHP" },
  { key: "PKR", text: "PKR", value: "PKR" },
  { key: "PLN", text: "PLN", value: "PLN" },
  { key: "QAR", text: "QAR", value: "QAR" },
  { key: "RON", text: "RON", value: "RON" },
  { key: "RSD", text: "RSD", value: "RSD" },
  { key: "RUB", text: "RUB", value: "RUB" },
  { key: "SAR", text: "SAR", value: "SAR" },
  { key: "SEK", text: "SEK", value: "SEK" },
  { key: "SGD", text: "SGD", value: "SGD" },
  { key: "SRD", text: "SRD", value: "SRD" },
  { key: "THB", text: "THB", value: "THB" },
  { key: "TND", text: "TND", value: "TND" },
  { key: "TRY", text: "TRY", value: "TRY" },
  { key: "TTD", text: "TTD", value: "TTD" },
  { key: "TWD", text: "TWD", value: "TWD" },
  { key: "TZS", text: "TZS", value: "TZS" },
  { key: "UAH", text: "UAH", value: "UAH" },
  { key: "UGX", text: "UGX", value: "UGX" },
  { key: "USD", text: "USD", value: "USD" },
  { key: "VEF", text: "VEF", value: "VEF" },
  { key: "VND", text: "VND", value: "VND" },
  { key: "XAF", text: "XAF", value: "XAF" },
  { key: "ZAR", text: "ZAR", value: "ZAR" },
  { key: "ZMW", text: "ZMW", value: "ZMW" },
]

const EUCountries = ['ES', 'NL','GB'];

export {
  checkMarkEvents,
  convertEpochToDate,
  convertEpochToDateAdvanced,
  convertNumberStringToDate,
  mapActivityName,
  timerStatusToColor,
  brokerRoAccess,
  OTP_TESTING,
  acceptedDigitalFileType,
  brokerType,
  tabFilters,
  searchDirections,
  allFilters,
  textFiltersLabelMapper,
  cardFiltersLabelMapper,
  textFilters,
  nctsTextFilters,
  euTextFilters,
  modals,
  actorTabs,
  countryList,
  monthList,
  yearList,
  months,
  cargoReleaseStatusMap,
  entrySummaryStatusMap,
  pscStatusMap,
  nctsStatusMap,
  transitStatusMap,
  statusMap,
  dateFormatter,
  midDateFormatter,
  countryOfDestinations,
  getStateText,
  ES_Mapper,
  CDS_CustomsMapper,
  languageList,
  ES_CustomsMapper,
  NL_CustomsMapper,
  guaranteeServiceType,
  spainGrnType,
  nlGrnOfc,
  spainGrnOfc,
  currency,
  EUCountries
};
